import React, { Component } from "react";
import { activeOptions, isTechnicianActive } from "../../utils/helpers";
import { formatNumber } from "../../utils/formatting";
import {
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  GET,
  GET_FILE,
  POST,
  PUT,
  DELETE,
  UPLOAD,
  Select,
  DatePicker,
  alert,
  company,
  profile,
  float,
  t,
  format_date,
  ActionIconButton,
  ACTION_ICONS,
  STICKY_ACTION_STYLE
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission.js";
import GlobalSearchBox from "../../components/GlobalSearchBox.js";
import {
  WORK_REQUEST_UPLOAD_RULES,
  pickFilesByRule,
  compressImageFiles,
  formatText,
  formatFileSize,
  toMB,
} from "../../utils/fileUpload";

const IMAGE_RULE = WORK_REQUEST_UPLOAD_RULES.image;
const VIDEO_RULE = WORK_REQUEST_UPLOAD_RULES.video;
const DOCUMENT_RULE = WORK_REQUEST_UPLOAD_RULES.document;
// เอกสารรับเฉพาะไฟล์งานเอกสารทั่วไป (ใบเสนอราคา/รายงานตรวจสอบ ฯลฯ) ไม่ใช่รูป/วิดีโอ
const DOCUMENT_FILE_ACCEPT = ".pdf,.doc,.docx,.xls,.xlsx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

// มอบหมายงานต่อ: ประเภทเอกสารถัดไป (ค่าตรงกับ next_document_type ฝั่ง backend)
// โทนสีตามชนิดเอกสาร - ใบเสนอราคา ฟ้า / ใบสั่งขาย ม่วง / ใบงาน เขียว
// enableField = \u0e0a\u0e37\u0e48\u0e2d\u0e1f\u0e34\u0e25\u0e14\u0e4c\u0e1a\u0e19\u0e2b\u0e21\u0e27\u0e14\u0e2b\u0e21\u0e39\u0e48\u0e04\u0e33\u0e23\u0e49\u0e2d\u0e07 (work_requisition_categories) \u0e17\u0e35\u0e48\u0e1a\u0e2d\u0e01\u0e27\u0e48\u0e32\u0e1b\u0e23\u0e30\u0e40\u0e20\u0e17\u0e40\u0e2d\u0e01\u0e2a\u0e32\u0e23\u0e19\u0e35\u0e49\u0e40\u0e1b\u0e34\u0e14\u0e43\u0e0a\u0e49\u0e07\u0e32\u0e19\u0e2d\u0e22\u0e39\u0e48\u0e44\u0e2b\u0e21
// \u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32\u0e17\u0e35\u0e48\u0e2b\u0e19\u0e49\u0e32 \u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32\u0e43\u0e1a\u0e07\u0e32\u0e19 > \u0e2b\u0e21\u0e27\u0e14\u0e2b\u0e21\u0e39\u0e48\u0e04\u0e33\u0e23\u0e49\u0e2d\u0e07 > \u0e41\u0e01\u0e49\u0e44\u0e02\u0e2b\u0e21\u0e27\u0e14\u0e2b\u0e21\u0e39\u0e48 - \u0e1b\u0e34\u0e14\u0e44\u0e27\u0e49 = disable \u0e01\u0e32\u0e23\u0e4c\u0e14\u0e19\u0e35\u0e49 \u0e40\u0e25\u0e37\u0e2d\u0e01\u0e44\u0e21\u0e48\u0e44\u0e14\u0e49
const NEXT_DOCUMENT_TYPES = [
    { value: "quotation", labelKey: "doc_type_quotation", caption: "QUOTATION", icon: "\uf15c", color: "#2563EB", softColor: "#EFF4FF", borderColor: "#BFD5FF", closeHintKey: "close_job_hint_quotation", enableField: "enable_quotation" },
    { value: "sales_order", labelKey: "doc_type_sales_order", caption: "SALES ORDER", icon: "\uf543", color: "#7C3AED", softColor: "#F5F0FF", borderColor: "#D8C7FB", closeHintKey: "close_job_hint_sales_order", enableField: "enable_sales_order" },
    { value: "work_order", labelKey: "doc_type_work_order", caption: "WORK ORDER", icon: "\uf7d9", color: "#16A34A", softColor: "#EDFAF1", borderColor: "#B7E7C6", closeHintKey: "close_job_hint_work_order", enableField: "enable_work_order" },
];
const DEFAULT_NEXT_DOCUMENT_TYPE = "quotation";

// process ของงาน - ค่ามาจากหมวดหมู่คำร้องที่เลือก (ตั้งค่าที่หน้าตั้งค่าคำขอบริการ)
// ใบสั่งงานที่สร้างจากคำร้องใบนี้จะรับ process ต่อไปด้วย จึงโชว์ให้เห็นตั้งแต่ตอนกรอกฟอร์ม
// โทนสี - ขายปกติ ฟ้า / ประกันโครงการ ส้ม (ให้ต่างจากสีเอกสารถัดไปด้านบน)
const PROCESS_NAME_VIEWS = {
    normal_sales: { labelKey: "process_normal_sales", icon: "\uf07a", color: "#2563EB" },
    project_warrantee: { labelKey: "process_project_warrantee", icon: "\uf3ed", color: "#B45309" },
};

// dropdown ที่ข้อมูลโตได้ไม่จำกัด (ลูกค้า/อะไหล่) ค้นหาฝั่ง server ทีละหน้า ไม่ดึงมาทั้งก้อน
const SEARCH_PAGE_SIZE = 50;

// ค่าที่ใช้แทน "ทรัพย์สินที่ยังไม่ผูกโครงการ" ในตัวเลือกโครงการของฟอร์มสร้างคำร้อง
const PROJECT_UNSPECIFIED = "__unspecified__";

// ไอคอนปุ่ม Return (Font Awesome "undo" - ชุดเดียวกับที่หน้าอื่นใช้)
const RETURN_ICON = "\uf0e2";

// ISS-003: หน้า Fast Call ให้กรอก "สรุปอาการที่ลูกค้าแจ้ง" ได้ไม่เกิน 20 ตัวอักษร
const FAST_CALL_SYMPTOM_MAX = 20;

export default class WorkRequests extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company_id: company?.id || "", // จาก Header ที่ให้มา
            filter_search: "",
            // ISS-030: "งานของฉัน" เป็นค่าเริ่มต้น และจำค่าที่ผู้ใช้เลือกไว้ข้ามการเข้าใช้งาน
            filter_scope: localStorage.getItem("cm-wr-scope") || "mine",
            tab: "pending", // เข้าหน้ามาให้อยู่แท็บ "รอดำเนินการ" ก่อน (all | pending | success | rejected) — success รวม approved ด้วย
            page: 1,
            page_size: 10,
            count: 0,
            data: [],
            summary_count: {
                draft: 0,
                pending: 0,
                success: 0,
                pending_approval: 0,
                approved: 0,
                rejected: 0,
                all: 0,
            },

            // Options from API
            data_customer: [],
            data_asset: [],
            data_reject_reasons: [],
            data_service_types: [],
            data_priorities: [],
            data_categories: [],
            data_technicians: [],
            data_parts: [],
            data_departments: [],

            // Modals
            modal_approve: false,
            modal_fast_call: false,
            modal_reject: false,
            // Return: ตีกลับใบคำร้อง (pending / pending_approval) ให้ผู้สร้าง กลับเป็น draft + เหตุผล (บังคับ)
            modal_return: false,
            return_reason: "",
            modal_create: false,
            view_mode: false,
            close_job_mode: false, // เปิด modal เดียวกับ view แต่มีปุ่มปิดงานท้ายฟอร์ม
            fast_call_view_mode: false,
            reject_view_mode: false,
            active_request: null,

            // Reject Form States
            reject_reason_id: "",
            reject_note: "",
            fast_call_technician: "",
            fast_call_date: "",
            fast_call_time: "",
            fast_call_duration: 0,
            fast_call_channel: "โทรศัพท์ตรง",
            fast_call_symptom: "",
            fast_call_guidance: "",
            fast_call_result: "visit",

            // Create/Update Form States
            uid: "",
            create_customer_id: "",
            create_customer_label: "",
            create_project_id: "",
            create_asset_id: "",
            create_contact_name_1: "",
            create_contact_phone_1: "",
            create_contact_name_2: "",
            create_contact_phone_2: "",
            create_contact_email: "",
            create_category_id: "",
            create_service_type_id: "",
            create_problem_desc: "",
            create_priority_id: "",
            create_internal_note: "",
            create_channel: "call",
            text_priority_id: "",

            // ขอเบิกอะไหล่ (ท้ายฟอร์ม)
            create_no_parts: false,
            create_parts_required_date: "",
            create_parts: [],
            create_part_id: "",

            // มอบหมายงานต่อ
            create_assigned_department_id: "",
            create_next_document_type: DEFAULT_NEXT_DOCUMENT_TYPE,

            select_asset: null,

            // Upload Files
            images: [],
            videos: [],
            documents: [],

            // Mock Data สำหรับส่วนที่ยังไม่มี API (เช่น ช่าง)
            technicians: [{ name: "Somchai T.", initials: "ST", bg: "#198754", status: "Available Now", statusColor: "success", distance: "5.2 km away", bestMatch: true, tags: [], hint: "" }],
            wo_type: "Corrective Maintenance",
            wo_priority: "Emergency",
            sla_template: "Emergency SLA (1hr/4hr)",
        };
    }

    // master data ของฟอร์ม (GetOptions) มีหลายเส้น ตารางไม่ควรรอเส้นที่ช้าที่สุดก่อนค่อยโผล่
    // จึงยิงคู่ขนานกันและเก็บ promise ไว้ ให้จุดที่ต้องใช้ options จริง ๆ (เปิด modal) มา await เอง
    optionsReady = Promise.resolve();

    async componentDidMount() {
        loading(true);
        this.optionsReady = this.GetOptions();
        // ISS-001: เข้ามาจาก global search (?search=WR-xxxx) ให้เติมคำค้นแล้วกรองให้เลย
        const keyword = new URLSearchParams(window.location.search).get("search") || "";
        if (keyword) {
            await new Promise((resolve) => this.setState({ filter_search: keyword }, resolve));
            const url = new URL(window.location.href);
            url.searchParams.delete("search");
            window.history.replaceState({}, "", url.pathname + url.search + url.hash);
        }
        // เข้ามาจากหน้ากำหนดเปลี่ยนไส้กรอง (?prefill=1&department_uid=&customer_uid=&asset_uid=) -> อ่านแล้วล้างออกจาก URL ทันที กัน refresh แล้วเปิดซ้ำ
        const prefill = this.readPrefillQuery();
        await this.Get(1);
        loading(false);
        if (prefill) await this.applyPrefill(prefill);
    }

    readPrefillQuery = () => {
        const query = new URLSearchParams(window.location.search);
        if (query.get("prefill") !== "1") return null;
        const prefill = {
            department_uid: query.get("department_uid") || "",
            customer_uid: query.get("customer_uid") || "",
            asset_uid: query.get("asset_uid") || "",
            category_uid: query.get("category_uid") || "",
            category_token: query.get("category_token") || "",
            followup_uid: query.get("followup_uid") || "",
        };
        ["prefill", "department_uid", "customer_uid", "asset_uid", "category_uid", "category_token", "followup_uid"].forEach((key) => query.delete(key));
        const qs = query.toString();
        window.history.replaceState({}, "", window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash);
        return prefill;
    };

    // เปิดฟอร์มสร้างพร้อมเติมแผนก/ลูกค้า/ทรัพย์สิน เติมเฉพาะ uid ที่หาเจอในบริษัท (ข้อมูลมาจาก API ปกติที่ scope ด้วย company) ที่ไม่เจอปล่อยว่างให้เลือกเอง
    applyPrefill = async ({ department_uid, customer_uid, asset_uid, category_uid, category_token, followup_uid }) => {
        await this.optionsReady;
        // setState ท้าย GetOptions ถูก batch ไว้ รอให้ commit ก่อนอ่านตัวเลือกแผนก/ความสำคัญ/ประเภทบริการจาก this.state
        await new Promise((resolve) => this.setState({}, resolve));
        const department = department_uid ? this.state.data_departments.find((d) => d.uid === department_uid) : null;

        let customerOption = null;
        let customerAssets = [];
        if (customer_uid) {
            customerAssets = await this.loadCustomerAssets(customer_uid);
            const owned = customerAssets.find((a) => this.getAssetCustomerId(a) === customer_uid);
            if (owned) {
                const base = this.toCustomerOption(owned.customer);
                // ดึงข้อมูลลูกค้าเต็ม (ผู้ติดต่อ/ความสำคัญ) แบบเดียวกับตอนเลือกในช่องลูกค้า ถ้าไม่ได้ใช้ข้อมูลย่อจากทรัพย์สิน
                const found = await GET("admin/customers", { page: 1, page_size: SEARCH_PAGE_SIZE, data_search: owned.customer.customer_code || "", search_scope: "display" });
                const full = found?.status ? (found.data || []).find((c) => c.uid === customer_uid) : null;
                customerOption = full ? this.toCustomerOption(full) : base;
            }
        }
        const asset = customerOption && asset_uid ? customerAssets.find((a) => a.uid === asset_uid && this.getAssetCustomerId(a) === customer_uid) : null;
        if (!department && !customerOption) return;

        const customerPriorityId = customerOption?.priority?.uid || customerOption?.priority_id || "";
        const matchedPriority = customerPriorityId ? this.state.data_priorities.find((priority) => priority.uid === customerPriorityId) : null;
        const customerState = customerOption
            ? {
                  data_customer: [customerOption],
                  data_asset: customerAssets,
                  create_customer_id: customer_uid,
                  create_customer_label: customerOption.label || "",
                  create_contact_name_1: ((customerOption.contact_first_name || "") + " " + (customerOption.contact_last_name || "")).trim(),
                  create_contact_phone_1: customerOption.contact_phone || "",
                  create_contact_email: customerOption.contact_email || "",
                  create_priority_id: customerPriorityId,
                  text_priority_id: this.getPriorityDescription(matchedPriority),
                  ...(asset ? { create_project_id: this.getAssetProjectId(asset) || PROJECT_UNSPECIFIED, create_asset_id: asset.uid, select_asset: asset } : {}),
              }
            : {};

        // หมวดหมู่คำร้อง: ใช้ uid จากรายงานไส้กรอง ถ้าไม่มีหาจากตัวย่อ (HHU/HQW) ในชื่อหมวด
        const tokenPattern = category_token ? new RegExp(`(^|[^A-Za-z0-9])${category_token}([^A-Za-z0-9]|$)`, "i") : null;
        const category =
            this.state.data_categories.find((c) => category_uid && c.uid === category_uid) ||
            (tokenPattern ? this.state.data_categories.find((c) => c.is_active !== false && tokenPattern.test(`${c.name_th || ""} ${c.name_en || ""}`)) : null);

        const formState = this.getCreateFormState();
        this.setState({
            modal_create: true,
            ...formState,
            ...customerState,
            ...(category ? this.getCategoryChangeState(category.uid, category, formState) : {}),
            ...(department ? { create_assigned_department_id: department.uid } : {}),
            // มาจากรายงานไส้กรอง: บันทึกผลติดตามหลังสร้าง WR สำเร็จเท่านั้น (getCreateFormState ล้างค่านี้ทุกครั้งที่ปิด/ยกเลิก)
            filter_alert_uid: asset ? followup_uid : "",
        });
    };

    // บันทึก Log ผลติดตามของรายงานไส้กรอง (result=wr + wr_uid) · ล้มเหลว = WR สร้างแล้วแต่ log ไม่ขึ้น แจ้งผู้ใช้ให้รู้
    recordFilterAlertFollowup = async (followupUid, wrUid) => {
        const saved = await POST(`admin/filter-alert/${followupUid}/followup`, { result: "wr", wr_uid: wrUid });
        if (!saved?.status) alert("", "warning", t("warning"), (typeof saved?.message === "string" && saved.message) || t("error_occurred"));
    };

    // state ที่ต้องเปลี่ยนตามหมวดหมู่คำร้องที่เลือก (ใช้ทั้งตอนเลือกเองและตอน prefill) current = state ฟอร์มปัจจุบัน
    getCategoryChangeState = (value, item, current = this.state) => {
        // หมวดหมู่ใหม่ปิดประเภทเอกสารที่เคยเลือกไว้ (enable_quotation/enable_sales_order/enable_work_order) -> ล้างค่าให้เลือกใหม่
        const disabledNow = item && NEXT_DOCUMENT_TYPES.some((docType) => docType.value === current.create_next_document_type && item[docType.enableField] === false);
        // เหลือประเภทเอกสารที่เปิดอยู่ตัวเดียว -> เลือกให้เลย
        const enabledDocTypes = item ? NEXT_DOCUMENT_TYPES.filter((docType) => item[docType.enableField] !== false) : [];
        const nextDocumentType = enabledDocTypes.length === 1 ? enabledDocTypes[0].value : disabledNow ? "" : current.create_next_document_type;
        return {
            create_category_id: value,
            create_service_type_id: item?.service_type_default?.uid || this.getDefaultServiceTypeId(),
            create_next_document_type: nextDocumentType,
            // หมวดหมู่ปิดเบิกอะไหล่ -> ติ๊กไม่เบิกอะไหล่ ล้างรายการที่ยังไม่บันทึก (รายการที่บันทึกแล้วคงไว้แบบอ่านอย่างเดียว)
            ...(item?.enable_parts_requisition === false
                ? {
                      create_parts: current.create_parts.filter((part) => part.uid),
                      create_part_id: "",
                      create_no_parts: !current.create_parts.some((part) => part.uid),
                      create_parts_required_date: current.create_parts.some((part) => part.uid) ? current.create_parts_required_date : "",
                  }
                : {}),
        };
    };

    // จำค่าที่เลือกไว้ใน localStorage เพื่อไม่ต้องกดใหม่ทุกครั้งที่เข้าหน้า (ISS-030)
    changeScope = (scope) => {
        localStorage.setItem("cm-wr-scope", scope);
        this.setState({ filter_scope: scope }, () => this.Get(1));
    };

    // ค้นด้วยคำค้น (Enter / ปุ่มค้นหา / เลือกจาก dropdown): ถ้าอยู่ "งานของฉัน" ให้สลับไป "ทั้งหมด" ก่อน
    // เพราะ dropdown แนะนำผลจากทุกใบ แต่ตาราง "งานของฉัน" กรองเฉพาะใบของฉัน - ค้นเจอแต่ตารางว่าง
    // ไม่บันทึกลง localStorage เพราะเป็นการสลับชั่วคราวเพื่อการค้นครั้งนี้ ไม่ใช่ค่าที่ผู้ใช้เลือกเอง
    searchWithScopeAll = (selectedTab) => {
        if (this.state.filter_search?.trim() && this.state.filter_scope === "mine") {
            this.setState({ filter_scope: "all" }, () => this.Get(1, selectedTab));
            return;
        }
        this.Get(1, selectedTab);
    };

    getCreateFormState = () => ({
        uid: "",
        create_customer_id: "",
        create_customer_label: "",
        create_project_id: "",
        create_asset_id: "",
        create_contact_name_1: "",
        create_contact_phone_1: "",
        create_contact_name_2: "",
        create_contact_phone_2: "",
        create_contact_email: "",
        create_category_id: "",
        create_service_type_id: this.getDefaultServiceTypeId(),
        create_problem_desc: "",
        create_priority_id: "",
        create_internal_note: "",
        create_channel: "call",
        text_priority_id: "",
        create_no_parts: false,
        create_parts_required_date: "",
        create_parts: [],
        create_part_id: "",
        create_assigned_department_id: "",
        create_next_document_type: DEFAULT_NEXT_DOCUMENT_TYPE,
        select_asset: null,
        images: [],
        videos: [],
        documents: [],
        view_mode: false,
        close_job_mode: false,
        // ตัวเลือกที่โหลดตามค่าที่เลือกไว้ ต้องล้างพร้อมฟอร์ม ไม่งั้นค้างจากใบก่อนหน้า
        data_customer: [],
        data_asset: [],
        data_parts: [],
        // uid ของรายการในรายงานไส้กรอง (เปิดหน้านี้มาจากปุ่ม "สร้าง WR") ว่าง = ไม่ได้มาจากรายงาน
        filter_alert_uid: "",
    });

    getFastCallFormState = () => {
        const now = new Date();
        const pad = (n) => String(n).padStart(2, "0");
        return {
            fast_call_technician: "",
            fast_call_date: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`,
            fast_call_time: `${pad(now.getHours())}:${pad(now.getMinutes())}`,
            fast_call_duration: 0,
            fast_call_channel: "โทรศัพท์ตรง",
            fast_call_symptom: "",
            fast_call_guidance: "",
            fast_call_result: "",
        };
    };

    getCurrentLang = () => localStorage.getItem("lang") || "TH";

    getCustomerDisplayName = (customer) => {
        const currentLang = this.getCurrentLang();

        if (currentLang === "EN") {
            return `${customer?.customer_code || ""} ${customer?.full_name_en || customer?.full_name_th || customer?.name || "-"}`;
        }

        return `${customer?.customer_code || ""} ${customer?.full_name_th || customer?.full_name_en || customer?.name || "-"}`;
    };

    getAssetCustomerId = (asset) => {
        return asset?.customer?.uid || asset?.customer_id || asset?.customer_uid || asset?.owner_customer_id || "";
    };

    getAssetProjectId = (asset) => {
        return asset?.project?.uid || asset?.project_uid || "";
    };

    // ป้ายโครงการใน dropdown: รหัสโครงการ (project_code) ตามด้วยชื่อโครงการ
    getAssetProjectLabel = (asset) => {
        const project = asset?.project;
        const label = [project?.project_code, project?.name].filter(Boolean).join(" ");

        return label || asset?.project_name || "-";
    };

    getAssetDisplayName = (asset) => {
        return asset?.part_name || asset?.part?.name || asset?.asset_name || asset?.name || "-";
    };

    // ป้ายใน dropdown เลือกทรัพย์สิน: description ของ Item Master แล้วตามด้วย Serial No.
    // ถ้า item master ไม่ได้กรอก description ไว้ ใช้ชื่อสินค้าแทนเพื่อไม่ให้ตัวเลือกว่างเปล่า
    getAssetDescription = (asset) => {
        return asset?.part?.description || asset?.part_description || this.getAssetDisplayName(asset);
    };

    getAssetLocationName = (asset) => {
        return asset?.location_name || asset?.location?.name || asset?.location?.location_name || "-";
    };

    getAssetWarrantyExpireDate = (asset) => {
        const warrantyDates = [
            ...(Array.isArray(asset?.customer_warranty) ? asset.customer_warranty.map((item) => item?.customer_warranty_expire_date) : []),
            asset?.customer_warranty_expire_date,
        ]
            .filter(Boolean)
            .map((date) => String(date).split("T")[0]);

        if (warrantyDates.length === 0) {
            return "";
        }

        return warrantyDates.reduce((latest, current) => {
            if (!latest) {
                return current;
            }

            return new Date(current) > new Date(latest) ? current : latest;
        }, "");
    };

    isWarrantyExpired = (expireDate) => {
        const raw = String(expireDate || "").trim();
        if (!raw) return true;
        const parsed = new Date(raw.split("T")[0]);
        if (isNaN(parsed.getTime())) return true;
        parsed.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return parsed < today;
    };

    getReceivedMeta = (item) => {
        const receivedSource = item?.created_at || item?.receive_date || item?.received_at || item?.updated_at || "";
        if (!receivedSource) {
            return {
                receivedAgo: "-",
                receivedDate: "",
            };
        }

        const receivedDate = new Date(receivedSource);
        if (Number.isNaN(receivedDate.getTime())) {
            return {
                receivedAgo: "-",
                receivedDate: "",
            };
        }

        const now = new Date();
        const diffMs = Math.max(0, now.getTime() - receivedDate.getTime());
        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        let receivedAgo = "-";
        if (diffDays > 0) {
            receivedAgo = `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
        } else if (diffHours > 0) {
            receivedAgo = `${diffHours} hr${diffHours > 1 ? "s" : ""} ago`;
        } else if (diffMinutes > 0) {
            receivedAgo = `${diffMinutes} min ago`;
        } else {
            receivedAgo = "Just now";
        }

        return {
            receivedAgo,
            receivedDate: String(receivedSource).split("T")[0],
        };
    };

    normalizeWorkRequestItem = (item) => {
        const normalizedAsset = item?.asset
            ? {
                  ...item.asset,
                  part_name: this.getAssetDisplayName(item.asset),
                  customer_warranty_expire_date: this.getAssetWarrantyExpireDate(item.asset),
                  location_name: this.getAssetLocationName(item.asset),
              }
            : null;
        const receivedMeta = this.getReceivedMeta(item);

        return {
            ...item,
            asset: normalizedAsset,
            ...receivedMeta,
        };
    };

    // ทรัพย์สินของลูกค้าที่เลือก ใช้เป็นฐานในการสร้างตัวเลือกโครงการและตัวเลือกทรัพย์สิน
    getCustomerAssets = () => {
        const { data_asset, create_customer_id } = this.state;

        if (!create_customer_id) {
            return [];
        }

        return data_asset.filter((asset) => this.getAssetCustomerId(asset) === create_customer_id);
    };

    // ตัวเลือกโครงการดึงจากทรัพย์สินของลูกค้า จึงเหลือเฉพาะโครงการที่มีทรัพย์สินให้เลือกจริง
    // ทรัพย์สินที่ยังไม่ผูกโครงการรวมไว้ใต้ตัวเลือก "ไม่ระบุโครงการ" เพื่อไม่ให้เลือกไม่ได้
    getProjectOptions = () => {
        const optionMap = new Map();

        this.getCustomerAssets().forEach((asset) => {
            const value = this.getAssetProjectId(asset) || PROJECT_UNSPECIFIED;

            if (!optionMap.has(value)) {
                optionMap.set(value, {
                    value,
                    label: value === PROJECT_UNSPECIFIED ? t("project_unspecified") : this.getAssetProjectLabel(asset),
                });
            }
        });

        // โหมดดูข้อมูล: ทรัพย์สินของคำร้องอาจไม่อยู่ในรายการปัจจุบัน (เช่นถูกย้ายลูกค้า) จึงเติมโครงการของมันเข้าไปด้วย
        const { select_asset } = this.state;
        if (select_asset) {
            const selectedProjectId = this.getAssetProjectId(select_asset) || PROJECT_UNSPECIFIED;

            if (!optionMap.has(selectedProjectId)) {
                optionMap.set(selectedProjectId, {
                    value: selectedProjectId,
                    label: selectedProjectId === PROJECT_UNSPECIFIED ? t("project_unspecified") : this.getAssetProjectLabel(select_asset),
                });
            }
        }

        return [...optionMap.values()];
    };

    getFilteredAssetOptions = () => {
        const { create_project_id } = this.state;

        if (!create_project_id) {
            return [];
        }

        return this.getCustomerAssets().filter((asset) => (this.getAssetProjectId(asset) || PROJECT_UNSPECIFIED) === create_project_id);
    };

    // -----------------------------------
    // ขอเบิกอะไหล่ (ท้ายฟอร์ม)
    // -----------------------------------

    // ต้องรู้หมวดหมู่คำร้อง + โครงการก่อน ถึงจะตรวจสิทธิ์เบิกอะไหล่ได้ (ตามสเปกหน้าจอ)
    canRequestParts = () => {
        const { create_category_id, create_project_id } = this.state;
        return !!create_category_id && !!create_project_id;
    };

    // หมวดหมู่ที่เลือกปิดการเบิกอะไหล่ (หน้าตั้งค่าใบงาน > หมวดหมู่คำร้อง) -> บังคับไม่เบิกอะไหล่ และแก้ส่วนอะไหล่ไม่ได้
    isPartsRequisitionClosed = (categoryId = this.state.create_category_id) => {
        const category = this.state.data_categories.find((item) => item.value === categoryId || item.uid === categoryId);
        return category?.enable_parts_requisition === false;
    };

    getRequestedPartsTotal = () => {
        return this.state.create_parts.reduce((total, part) => total + (Number(part.quantity) || 0), 0);
    };

    handleAddRequestedPart = () => {
        const { create_part_id, data_parts, create_parts } = this.state;
        if (!create_part_id) return;

        const selectedPart = data_parts.find((part) => part.value === create_part_id || part.uid === create_part_id);
        if (!selectedPart) return;

        // เลือกอะไหล่ตัวเดิมซ้ำ = บวกจำนวนเพิ่มให้แถวเดิม ไม่สร้างแถวใหม่
        const existingPart = create_parts.find((part) => part.part_id === create_part_id);
        const nextParts = existingPart
            ? create_parts.map((part) => (part.part_id === create_part_id ? { ...part, quantity: (Number(part.quantity) || 0) + 1 } : part))
            : [
                  ...create_parts,
                  {
                      key: `new_${create_part_id}`,
                      uid: "", // ยังไม่มีแถวในฐานข้อมูล ส่ง uid ว่างไปให้ backend สร้างใหม่
                      part_id: create_part_id,
                      part_number: selectedPart.part_number || "-",
                      part_name: selectedPart.name || selectedPart.label || "-",
                      uom_name: selectedPart.uom?.name || "",
                      quantity: 1,
                  },
              ];

        this.setState({ create_parts: nextParts, create_part_id: "" });
    };

    handleRequestedPartChange = (partKey, quantity) => {
        this.setState((prevState) => ({
            create_parts: prevState.create_parts.map((part) => (part.key === partKey ? { ...part, quantity } : part)),
        }));
    };

    handleRemoveRequestedPart = async (partKey) => {
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        this.setState((prevState) => ({ create_parts: prevState.create_parts.filter((part) => part.key !== partKey) }));
    };

    // ติ๊ก "ไม่เบิกอะไหล่" แล้วมีรายการค้างอยู่ ต้องยืนยันก่อนล้างทิ้ง
    handleToggleNoParts = async (checked) => {
        if (checked && this.state.create_parts.length > 0) {
            if (!(await alert("", "warning", t("confirm"), t("confirm_clear_parts_no_requisition"), t("confirm"), t("cancel")))) return;
        }

        this.setState({
            create_no_parts: checked,
            ...(checked ? { create_parts: [], create_part_id: "", create_parts_required_date: "" } : {}),
        });
    };

    // "CIT · 19/08/2569 08:03" - ชื่อผู้สร้าง + เวลาที่สร้างใบคำร้อง
    getRequestCreatorText = (request) => {
        const creator = request?.created_by_user;
        const name = creator?.full_name || creator?.user_code || "-";
        const createdAt = request?.created_at ? format_date(request.created_at, "dd/mm/yyyy hh:mm", "th") : "";

        return [name, createdAt].filter(Boolean).join(" · ");
    };

    getPriorityDescription = (priorityItem) => {
        if (!priorityItem) {
            return "";
        }

        return `${priorityItem.name_th} - ${t("must_respond_within")} ${priorityItem.sla_response_time_start} - ${priorityItem.sla_response_time_end} ${priorityItem.sla_response_time_start_unit}`;
    };

    // service type ที่ fix ไว้ใน database ให้ใช้เป็นค่าเริ่มต้นเมื่อ category ไม่มี service type ผูกไว้
    getDefaultServiceTypeId = () => {
        const defaultServiceType = this.state.data_service_types.find((item) => item?.name_en === "Corrective Maintenance");

        return defaultServiceType?.uid || "";
    };

    getTechnicianDisplayName = (technician) => {
        let nickname_th = technician?.nickname_th ? ` (${technician?.nickname_th})` : "";
        let nickname_en = technician?.nickname_en ? ` (${technician?.nickname_en})` : "";
        return `${
            [technician?.first_name_th, technician?.last_name_th, nickname_th].filter(Boolean).join(" ") ||
            [technician?.first_name_en, technician?.last_name_en, nickname_en].filter(Boolean).join(" ") || "-"
        }`;
    };

    // -----------------------------------
    // API Methods
    // -----------------------------------

    // ----- dropdown ที่ค้นหาฝั่ง server -----
    // token กันผลลัพธ์ที่ตอบช้ามาทับผลลัพธ์ของคำค้นล่าสุด
    customerSearchToken = 0;
    partSearchToken = 0;
    assetLoadToken = 0;

    toCustomerOption = (customer) => ({
        ...customer,
        group: undefined,
        value: customer.uid,
        label: this.getCustomerDisplayName(customer),
    });

    toAssetOption = (asset) => ({
        ...asset,
        part_name: this.getAssetDisplayName(asset),
        customer_warranty_expire_date: this.getAssetWarrantyExpireDate(asset),
        location_name: this.getAssetLocationName(asset),
        value: asset.uid,
        label: [this.getAssetDescription(asset), asset.serial_number].filter(Boolean).join(" : ") || "-",
    });

    toPartOption = (part) => ({
        ...part,
        value: part.uid,
        label: [part.part_number, part.name].filter(Boolean).join(" - ") || part.name || "-",
    });

    // dropdown ลูกค้า: ค้นเฉพาะที่แสดงใน label (รหัส + ชื่อ) ไม่ค้นเบอร์/อีเมล/เลขผู้เสียภาษี
    // เพราะผู้ใช้จะเห็นรายการที่ตรงแต่ดูไม่ออกว่าตรงตรงไหน
    searchCustomers = async (keyword) => {
        const token = ++this.customerSearchToken;
        const result = await GET("admin/customers", { page: 1, page_size: SEARCH_PAGE_SIZE, data_search: keyword || "", search_scope: "display" });
        if (token !== this.customerSearchToken || !result?.status) return;

        this.setState({ data_customer: (result.data || []).map(this.toCustomerOption) });
    };

    searchParts = async (keyword) => {
        const token = ++this.partSearchToken;
        const result = await GET("warehouse/part-masters", { page: 1, page_size: SEARCH_PAGE_SIZE, data_search: keyword || "" });
        if (token !== this.partSearchToken || !result?.status) return;

        this.setState({ data_parts: (result.data || []).map(this.toPartOption) });
    };

    // ทรัพย์สินโหลดเฉพาะของลูกค้าที่เลือก (หลักสิบรายการ) จึงยังกรองโครงการ/ทรัพย์สินในเครื่องได้เหมือนเดิม
    loadCustomerAssets = async (customerUid) => {
        const token = ++this.assetLoadToken;

        if (!customerUid) {
            this.setState({ data_asset: [] });
            return [];
        }

        const result = await GET("admin/assets", { page: 0, page_size: 10000, lite: "true", customer_id: customerUid });
        if (token !== this.assetLoadToken || !result?.status) return [];

        const options = (result.data || []).map(this.toAssetOption);
        this.setState({ data_asset: options });
        return options;
    };

    // ตัวเลือกแผนกที่รับผิดชอบ: แสดง department_code ตามด้วยชื่อแผนก และเรียงตาม department_code
    toDepartmentOptions = (departments) => {
        return (departments || [])
            .map((e) => ({
                ...e,
                value: e.uid,
                label: [e.department_code, e.name].filter(Boolean).join(" ") || "-",
            }))
            .sort((a, b) => String(a.department_code || "").localeCompare(String(b.department_code || ""), undefined, { numeric: true, sensitivity: "base" }));
    };

    // ดึงข้อมูล Master Data สำหรับ Dropdown
    GetOptions = async () => {
        // ลูกค้า/ทรัพย์สิน/อะไหล่ ไม่โหลดที่นี่ - ลูกค้ากับอะไหล่ค้นหาฝั่ง server ตอนพิมพ์
        // ส่วนทรัพย์สินโหลดเฉพาะของลูกค้าที่เลือก (loadCustomerAssets)
        let [res_reject, res_service, res_priority, res_category, res_technicians, res_departments] = await Promise.all([
            GET("admin/work-requisition/reject-reasons", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/service-types", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/priorities", { page: 0, page_size: 10000 }),
            GET("admin/work-requisition/categories", { page: 0, page_size: 10000 }),
            // lite=true: dropdown ช่างใน fast call ใช้แค่ชื่อ/uid ไม่ต้อง join skills/vehicles/role
            GET("admin/technicians", { page: 0, page_size: 10000, lite: "true" }),
            GET("admin/departments", { page: 0, page_size: 10000 }),
        ]);

        this.setState({
            data_reject_reasons: res_reject?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_service_types: res_service?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_priorities: res_priority?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_categories: res_category?.data?.map((e) => ({ ...e, value: e.uid, label: e.name_th })) || [],
            data_technicians: res_technicians?.data || [],
            data_departments: this.toDepartmentOptions(res_departments?.data),
        });
    };

    Get = async (page, selectedTab = this.state.tab) => {
        loading(true);
        // แท็บ "สำเร็จ" รวมคำร้องที่ปิดงานแล้ว (success) กับที่ออก WO แล้ว (approved) ไว้ด้วยกัน
        const status = selectedTab === "all" ? "" : selectedTab === "success" ? "success,approved" : selectedTab;
        let [result, summaryResult] = await Promise.all([
            GET("admin/work-requisitions", {
                page_size: this.state.page_size,
                page: page,
                // view=list: backend จำกัดคอลัมน์ asset/work_order ที่ join มาให้เหลือเท่าที่ DTO ใช้ (ผลลัพธ์เท่าเดิม)
                view: "list",
                data_search: this.state.filter_search || "",
                type: "",
                status,
                scope: this.state.filter_scope,
            }),
            // summary=true: backend นับตามสถานะด้วย GROUP BY ไม่ต้องดึงทุกแถวมานับเอง
            GET("admin/work-requisitions", {
                summary: "true",
                data_search: this.state.filter_search || "",
                type: "",
                scope: this.state.filter_scope,
            }),
        ]);

        if (result?.status) {
            const summary_count = {
                draft: 0, pending: 0, success: 0, pending_approval: 0, approved: 0, rejected: 0, all: 0,
                ...(summaryResult?.status && summaryResult.data ? summaryResult.data : {}),
            };

            this.setState({
                data: (result.data || []).map((item) => this.normalizeWorkRequestItem(item)),
                count: result.pagination?.count || 0,
                page,
                tab: selectedTab,
                summary_count,
            });
        }
        loading(false);
    };

    isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    // รวมรายชื่อช่องบังคับ (*) ที่ยังไม่มีข้อมูล ใช้ร่วมกันทั้งตอนบันทึกและตอนเช็คว่าปิดงานได้ไหม
    getMissingRequiredFields = () => {
        const {
            create_customer_id,
            create_project_id,
            create_asset_id,
            create_category_id,
            create_service_type_id,
            create_problem_desc,
            create_priority_id,
            create_assigned_department_id,
            create_next_document_type,
        } = this.state;

        const missing = [];
        if (!create_customer_id) missing.push(t("customer"));
        if (!create_project_id) missing.push(t("label_project"));
        if (!create_asset_id) missing.push(t("asset"));
        if (!create_category_id) missing.push(t("req_category"));
        if (!create_service_type_id) missing.push(t("service_type"));
        if (!create_problem_desc?.trim()) missing.push(t("problem_description"));
        if (!create_priority_id) missing.push(t("wr_urgency_level"));
        // มอบหมายงานต่อ: แอดมินต้องเลือกแผนกและประเภทเอกสารถัดไปเอง
        if (!create_assigned_department_id) missing.push(t("responsible_department"));
        if (!create_next_document_type) missing.push(t("next_document_type_label"));

        return missing;
    };

    // asDraft=true (ปุ่ม Save Draft): ไม่บังคับช่องจำเป็น บันทึกเป็น status draft เห็นเฉพาะผู้สร้าง ยังไม่เข้า flow / ไม่สร้าง WO
    CreateUpdate = async (asDraft = false) => {
        const {
            uid,
            company_id,
            create_customer_id,
            create_asset_id,
            create_contact_name_1,
            create_contact_phone_1,
            create_contact_name_2,
            create_contact_phone_2,
            create_contact_email,
            create_channel,
            create_category_id,
            create_service_type_id,
            create_problem_desc,
            create_priority_id,
            create_internal_note,
            create_no_parts,
            create_parts_required_date,
            create_parts,
            create_assigned_department_id,
            create_next_document_type,
        } = this.state;

        // ตรวจครบทุกช่องที่ติดดาวแดง (*) แล้วบอกชื่อช่องที่ยังขาดในข้อความเดียว (Save Draft ข้ามการตรวจนี้)
        const missing = asDraft ? [] : this.getMissingRequiredFields();

        if (missing.length > 0) {
            alert("", "warning", t("warning"), `${t("required_fields_missing")}: ${missing.join(", ")}`);
            return;
        }

        // อีเมลลูกค้าแก้ไขได้ในคำร้อง (ไม่กระทบข้อมูลหลักลูกค้า) จึงต้องตรวจรูปแบบก่อนบันทึก
        if (create_contact_email?.trim() && !this.isValidEmail(create_contact_email.trim())) {
            alert("", "warning", t("warning"), t("invalid_email_address"));
            return;
        }

        if (await alert("", "info", t("confirm"), asDraft ? t("wr_save_draft_confirm") : t("confirm_submission"), t("confirm"), t("cancel"))) {
            loading(true);

            // อัปโหลดไฟล์ทีละไฟล์ (presigned URL ยิงตรงเข้า S3 -> fallback base64) เพื่อนำ path กลับมาใส่ใน body
            // ก่อนบันทึกข้อมูล work-request ทั้งหมด
            const attachments = await this.uploadAllAttachments();

            if (attachments === null) {
                // มีไฟล์อัปโหลดไม่สำเร็จ (POST แสดง alert แล้ว) ยกเลิกการบันทึก
                loading(false);
                return;
            }

            // ไม่ติ๊ก "ไม่เบิกอะไหล่" แต่ไม่ได้เพิ่มอะไหล่ไว้เลย = ไม่เบิกอะไหล่
            // หมวดหมู่ปิดเบิกอะไหล่: ใบเดิมที่มีอะไหล่อยู่แล้วคงไว้ (backend ไม่ลบ/ไม่รับ parts ใหม่) ใบอื่นบังคับไม่เบิก
            const noPartsRequisition = create_no_parts || create_parts.length === 0 || (this.isPartsRequisitionClosed() && !create_parts.some((part) => part.uid));

            let body = {
                company_id: company_id,
                customer_id: create_customer_id,
                asset_id: create_asset_id,
                contact_name_1: create_contact_name_1,
                contact_phone_1: create_contact_phone_1,
                contact_name_2: create_contact_name_2,
                contact_phone_2: create_contact_phone_2,
                contact_email: create_contact_email?.trim() || "",
                channel: create_channel,
                work_requisition_categories_id: create_category_id,
                work_requisition_service_types_id: create_service_type_id,
                problem_description: create_problem_desc,
                work_requisition_priorities_id: create_priority_id,
                work_requisition_reject_reasons_id: "",
                reject_description: "",
                // ส่งจริง = pending (draft ที่ส่งแล้วเข้า flow ปกติ และ backend ล้างเหตุผลที่ถูก Return) / Save Draft = draft
                status: asDraft ? "draft" : "pending",
                internal_remark: create_internal_note,
                // ขอเบิกอะไหล่ - ติ๊ก "ไม่เบิกอะไหล่" หรือไม่ได้ใส่อะไหล่เลย ถือว่าไม่เบิกอะไหล่ (ส่งรายการว่างไปล้างของเดิม)
                no_parts_requisition: noPartsRequisition,
                parts_required_date: noPartsRequisition ? null : create_parts_required_date || null,
                parts: noPartsRequisition
                    ? []
                    : create_parts.map((part, index) => ({
                          ...(part.uid ? { uid: part.uid } : {}),
                          part_id: part.part_id,
                          quantity: Number(part.quantity) || 1,
                          sequence: index + 1,
                      })),
                // มอบหมายงานต่อ
                assigned_department_id: create_assigned_department_id,
                next_document_type: create_next_document_type,
                attachments: attachments,
                is_active: true,
            };

            let result = !uid ? await POST("admin/work-requisitions", body) : await PUT("admin/work-requisitions/" + uid, body);

            if (result?.status === true) {
                // สร้างใหม่: โชว์เลข WR ที่ backend ออกให้ไว้บรรทัด 2 - swal ใช้ text เป็น textContent ขึ้นบรรทัดใหม่ไม่ได้ จึงส่ง html
                // escape เลข WR ก่อนใส่ html เผื่อค่าจาก API มีอักขระพิเศษ
                // มาจากรายงานไส้กรอง: บันทึกผลติดตาม "นัดหมายได้ → สร้าง WR" พร้อมเลข WR หลังสร้างสำเร็จเท่านั้น (ฉบับร่างไม่นับ) · เครื่องต้องเป็นเครื่องเดิมของรายการ
                if (!uid && !asDraft && this.state.filter_alert_uid && result?.data?.uid) {
                    await this.recordFilterAlertFollowup(this.state.filter_alert_uid, result.data.uid);
                }
                const wrNumber = !uid ? String(result?.data?.wr_number || "").replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`) : "";
                if (wrNumber) {
                    alert("#", "success", t("success"), "", "", "", { html: `The transaction was completed successfully.<br />${t("wr_number")}: ${wrNumber}` });
                } else {
                    alert("#", "success");
                }
                this.setState({ modal_create: false, ...this.getCreateFormState() });
                // Save Draft: ไปแท็บ "ร่าง" ให้เห็นใบที่เพิ่งบันทึกทันที (แท็บ pending จะไม่มีใบนี้)
                this.Get(asDraft ? 1 : this.state.page, asDraft ? "draft" : this.state.tab);
            } else {
                alert("", "warning", t("warning"), result?.message || t("error_occurred"));
            }
            loading(false);
        }
    };

    SubmitApprove = async () => {
        const { active_request, company_id } = this.state;

        // อนุมัติแล้ว backend จะสร้างใบงานให้ทันที ข้อความยืนยันจึงต้องบอกผลลัพธ์นี้ ไม่ใช่ "บันทึกข้อมูล" กลาง ๆ
        if (await alert("", "info", t("confirm"), t("confirm_approve_work_request"), t("approve"), t("cancel"))) {
            loading(true);
            let body = {
                company_id: company_id,
                status: "approved",
                is_active: true,
                // ใส่ฟิลด์อื่นๆ เดิมเข้าไปด้วยหาก API บังคับ Require
            };

            let result = await PUT("admin/work-requisitions/" + active_request.uid, body);
            if (result?.status) {
                // อนุมัติแล้ว backend สร้างใบงาน (WO) ให้ทันที -> โชว์เลขที่ WO ที่เพิ่งสร้างไว้ใน popup สำเร็จด้วย
                // escape เลข WO ก่อนใส่ html เผื่อค่าจาก API มีอักขระพิเศษ
                const woNumber = String(result?.data?.work_order?.wo_number || "").replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
                if (woNumber) {
                    alert("#", "success", t("success"), "", "", "", { html: `The transaction was completed successfully.<br />${t("wo_number")}: ${woNumber}` });
                } else {
                    alert("#", "success");
                }
                this.setState({ modal_reject: false });
                this.Get(this.state.page);
            } else {
                alert("", "warning", t("warning"), result?.message || t("error_occurred"));
            }
            loading(false);
        }
    };
    // ปิดงาน
    // - เอกสารถัดไปเป็น "ใบงาน" ข้ามขั้นตอนรออนุมัติ: ส่งสถานะ approved ตรง ๆ
    //   (backend จะสร้างใบงาน WO ให้ทันทีตอนสถานะเปลี่ยนเป็น approved)
    // - เอกสารถัดไปอื่น (ใบเสนอราคา/ใบสั่งขาย) ปิดใบคำร้องเป็น "สำเร็จ" ได้เลย
    SubmitCloseJob = async () => {
        const { active_request, company_id, create_next_document_type } = this.state;

        // กันไว้อีกชั้น เผื่อข้อมูลบังคับ (*) ยังไม่ครบ (ปกติปุ่มจะถูก disable อยู่แล้ว)
        const missing = this.getMissingRequiredFields();
        if (missing.length > 0) {
            alert("", "warning", t("warning"), `${t("close_job_missing_fields")}: ${missing.join(", ")}`);
            return;
        }

        const isCreateWorkOrder = create_next_document_type === "work_order";
        if (!(await alert("", "info", t("confirm"), isCreateWorkOrder ? t("confirm_close_job_create_wo") : t("confirm_close_job"), t("confirm"), t("cancel")))) return;

        const nextStatus = isCreateWorkOrder ? "approved" : "success";

        loading(true);

        // แผนกที่ถูกส่งมอบงานต่อแนบเอกสารเพิ่มเติมได้ตอนปิดงาน (เช่น รายงานตรวจสอบ) - ต้องส่งไฟล์แนบทั้งชุดกลับไปด้วย
        // ไม่งั้นไฟล์เดิม (รูป/วิดีโอ/เอกสารของคนอื่น) จะถูกลบทิ้งเพราะ backend sync แบบแทนที่ทั้งชุด
        const attachments = await this.uploadAllAttachments();
        if (attachments === null) {
            loading(false);
            return;
        }

        const result = await PUT("admin/work-requisitions/" + active_request.uid, {
            company_id: company_id,
            status: nextStatus,
            is_active: true,
            attachments,
        });
        loading(false);

        if (!result?.status) {
            alert("", "warning", t("warning"), result?.message || t("error_occurred"));
            return;
        }

        // ปิดงานแบบสร้างใบงาน (WO) -> backend ส่งเลขที่ WO ที่เพิ่งสร้างกลับมา โชว์ไว้ใน popup สำเร็จด้วย
        // escape เลข WO ก่อนใส่ html เผื่อค่าจาก API มีอักขระพิเศษ
        const woNumber = String(result?.data?.work_order?.wo_number || "").replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
        if (woNumber) {
            alert("#", "success", t("success"), "", "", "", { html: `The transaction was completed successfully.<br />${t("wo_number")}: ${woNumber}` });
        } else {
            alert("#", "success");
        }
        this.setState({ modal_create: false, ...this.getCreateFormState() });
        this.Get(this.state.page);
    };

    SubmitReject = async () => {
        const { active_request, reject_reason_id, reject_note, company_id } = this.state;

        if (!reject_reason_id) {
            alert("", "warning", t("warning"), t("reject_reason_required"));
            return;
        }

        loading(true);
        let body = {
            company_id: company_id,
            work_requisition_reject_reasons_id: reject_reason_id,
            reject_description: reject_note,
            status: "rejected",
            is_active: true,
            // ใส่ฟิลด์อื่นๆ เดิมเข้าไปด้วยหาก API บังคับ Require
        };

        let result = await PUT("admin/work-requisitions/" + active_request.uid, body);
        if (result?.status) {
            alert("#", "success");
            this.setState({ modal_reject: false });
            this.Get(this.state.page);
        } else {
            alert("", "warning", t("warning"), result?.message || t("error_occurred"));
        }
        loading(false);
    };

    openReturnModal = (request) => {
        this.setState({ modal_return: true, active_request: request, return_reason: "" });
    };

    // Return: ตีกลับให้ผู้สร้าง (ต้องมีเหตุผลทุกครั้ง) -> ใบกลับเป็น draft ผู้สร้างแก้แล้วส่งใหม่ได้
    SubmitReturn = async () => {
        const { active_request, return_reason } = this.state;

        if (!return_reason.trim()) {
            alert("", "warning", t("warning"), t("wr_return_reason_required"));
            return;
        }

        loading(true);
        const result = await PUT("admin/work-requisitions/" + active_request.uid + "/return", { reason: return_reason.trim() });
        if (result?.status) {
            alert("#", "success");
            this.setState({ modal_return: false, return_reason: "" });
            this.Get(this.state.page);
        } else {
            alert("", "warning", t("warning"), result?.message || t("error_occurred"));
        }
        loading(false);
    };

    Delete = async (id) => {
        if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
            loading(true);
            let result = await DELETE("admin/work-requisitions/" + id, null);
            if (result?.status) {
                alert("#", "success");
                this.Get(1);
            } else {
                alert("", "warning", t("warning"), result?.message || t("error_occurred"));
            }
            loading(false);
        }
    };

    componentWillUnmount() {
        // คืนหน่วยความจำ object URL ที่สร้างไว้สำหรับ preview
        [...(this.state.images || []), ...(this.state.videos || []), ...(this.state.documents || [])].forEach((item) => {
            if (item?.url && item.url.startsWith("blob:")) {
                URL.revokeObjectURL(item.url);
            }
            if (item?.preview_url && item.preview_url.startsWith("blob:")) {
                URL.revokeObjectURL(item.preview_url);
            }
        });
    }

    // ไฟล์แนบที่อัปโหลดแล้วเก็บเป็น S3 URL ตรงๆ ซึ่งเข้าไม่ได้ (bucket policy ปิด public read กับโฟลเดอร์ใหม่ -> AccessDenied)
    // ต้องอ่านผ่าน endpoint ใหม่ (แนบ Authorization + company-uid) แล้วแปลงเป็น blob url ไว้ให้ <img>/<video>/<a> ใช้แสดงผลแทน
    // ใช้กับรูป/วิดีโอเท่านั้น (ต้อง preview ทันทีตอนเปิดฟอร์ม) ส่วนเอกสารโหลดตอนกดดูแทน (จำนวนไม่จำกัด โหลดทุกไฟล์ล่วงหน้าจะหนักเกินไป)
    hydratePreviewUrls = async (items) => {
        await Promise.all(
            (items || []).map(async (item) => {
                if (!item?.uid) return; // ไฟล์ที่เพิ่งเลือก ยังไม่บันทึก ใช้ local blob url เดิมได้เลย
                const result = await GET_FILE(`admin/attachments/${item.uid}`);
                if (result?.status === true && result.blob) {
                    item.preview_url = URL.createObjectURL(result.blob);
                }
            })
        );
    };

    // ดาวน์โหลดเอกสารแนบ (คลิกชื่อไฟล์) ด้วยชื่อไฟล์เดิมเสมอ (backend คืนไฟล์เป็น stream ไม่ใช่ JSON
    // <a href> ธรรมดาแนบ auth header เองไม่ได้ จึงต้องยิงผ่าน GET_FILE แล้วสร้าง blob url ให้ <a download> ใช้แทน)
    // ไฟล์ที่ยังไม่บันทึก (ไม่มี uid) เป็น local blob url อยู่แล้ว ดาวน์โหลดได้ตรงๆ ไม่ต้องยิง endpoint
    openDocument = async (doc) => {
        const saveAs = (url, name) => {
            const link = document.createElement("a");
            link.href = url;
            link.download = name || "";
            document.body.appendChild(link);
            link.click();
            link.remove();
        };

        if (!doc?.uid) {
            if (doc?.url) saveAs(doc.url, doc.name);
            return;
        }

        loading(true);
        try {
            const result = await GET_FILE(`admin/attachments/${doc.uid}`, { download: 1 });
            if (result?.status !== true || !result.blob) {
                alert("", "warning", t("warning"), result?.message || t("no_data_found"));
                return;
            }
            const blobUrl = URL.createObjectURL(result.blob);
            saveAs(blobUrl, doc.name);
            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
        } finally {
            loading(false);
        }
    };

    // -----------------------------------
    // File Helpers
    // -----------------------------------
    // แปลง File เป็น object สำหรับ preview พร้อม url ชั่วคราว
    mapFilesToItems = (files) =>
        Array.from(files).map((file) => ({
            file,
            name: file.name,
            size: file.size,
            type: file.type,
            url: URL.createObjectURL(file),
        }));

    // รวมเหตุผลที่ไฟล์ถูกปฏิเสธเป็นข้อความเดียว แล้วแจ้งครั้งเดียว
    // (alert() ของโปรเจกต์จะ "ทิ้ง" ข้อความที่ยิงซ้อนขณะมี modal เปิดอยู่)
    notifyRejectedFiles = ({ wrongType, tooBig, overLimit, rule }, fileType) => {
        const messages = [];

        if (wrongType.length > 0) {
            messages.push(`${t("file_type_not_allowed")}: ${wrongType.join(", ")}`);
        }
        if (tooBig.length > 0) {
            messages.push(`${t("file_too_large")} (${t("max")} ${toMB(rule.maxSize)} MB): ${tooBig.join(", ")}`);
        }
        if (overLimit > 0) {
            const key = fileType === "video" ? "max_videos_reached" : "max_images_reached";
            messages.push(formatText(t(key), { count: rule.maxFiles, excess: overLimit }));
        }

        if (messages.length > 0) {
            alert("", "warning", t("warning"), messages.join(" · "));
        }
    };

    // เพิ่มไฟล์เข้า state ตามกติกา: ชนิดไฟล์ -> ขนาดต่อไฟล์ -> จำนวนสูงสุด -> บีบอัดรูป
    // fileType: "image" | "video" | "document"
    addFiles = async (fileList, fileType) => {
        const stateKey = fileType === "video" ? "videos" : fileType === "document" ? "documents" : "images";
        const current = this.state[stateKey] || [];

        const result = pickFilesByRule(fileList, fileType, current.length);
        this.notifyRejectedFiles(result, fileType);
        if (result.accepted.length === 0) return;

        // บีบอัดรูปก่อนเก็บเข้า state เพื่อลดพื้นที่จัดเก็บบน S3 (วิดีโอบีบฝั่ง browser ไม่ได้ ใช้ตามเดิม)
        let files = result.accepted;
        if (fileType === "image") {
            loading(true);
            try {
                files = await compressImageFiles(result.accepted);
            } finally {
                loading(false);
            }
        }

        const newItems = this.mapFilesToItems(files);
        this.setState((prev) => ({ [stateKey]: [...prev[stateKey], ...newItems] }));
    };

    // อัปโหลดไฟล์ทีละไฟล์ (presigned URL -> fallback base64) แล้วคืน array ของ attachment object
    // { uid?, file_path, file_name, file_type, mime_type, file_size }
    // คืนค่า null หากมีไฟล์ใดอัปโหลดไม่สำเร็จ
    uploadAttachments = async (items, folder, fileType) => {
        const uploaded = [];

        for (const item of items || []) {
            // ไฟล์ที่อัปโหลดแล้ว (กรณีดู/แก้ไข) ส่ง meta เดิมกลับไป ไม่ต้องอัปโหลดซ้ำ
            if (!item?.file && typeof item?.url === "string" && item.url.includes("://")) {
                uploaded.push({
                    uid: item.uid,
                    file_path: item.url,
                    file_name: item.name || null,
                    file_type: item.file_type || fileType,
                    mime_type: item.mime_type || null,
                    file_size: item.file_size ?? null,
                });
                continue;
            }

            // backstop: กันไฟล์ใหญ่เกินหลุดมาถึงขั้นอัปโหลด
            const rule = WORK_REQUEST_UPLOAD_RULES[fileType] || WORK_REQUEST_UPLOAD_RULES.image;
            if (item?.file && item.file.size > rule.maxSize) {
                alert("", "warning", t("warning"), `${t("file_too_large")} (${t("max")} ${toMB(rule.maxSize)} MB): ${item?.name || ""}`);
                return null;
            }

            const res = await UPLOAD(item.file, { folder });

            if (res?.status === true && res?.data?.file_path) {
                uploaded.push({
                    file_path: res.data.file_path,
                    file_name: item.name || res.data.file_name || null,
                    file_type: fileType,
                    mime_type: res.data.mime_type || item.type || null,
                    file_size: res.data.file_size ?? item.size ?? null,
                });
            } else {
                alert("", "warning", t("warning"), `${t("upload")} "${item?.name || ""}" ${t("fail")}`);
                return null;
            }
        }

        return uploaded;
    };

    // อัปโหลดไฟล์แนบทั้ง 3 ประเภท (รูป/วิดีโอ/เอกสาร) รวมเป็น array เดียว สำหรับส่งเข้า body ตอนบันทึก
    // ต้องส่งครบทุกประเภทเสมอ (ไม่ใช่เฉพาะประเภทที่เพิ่งแก้) เพราะ backend sync ไฟล์แนบแบบแทนที่ทั้งชุดต่อใบคำร้อง
    // (ดู attachmentService.syncAttachments) - ถ้าส่งไม่ครบ ไฟล์เดิมประเภทที่ไม่ได้ส่งมาจะถูกลบทิ้งไปด้วย
    // คืนค่า null หากมีไฟล์ใดอัปโหลดไม่สำเร็จ
    uploadAllAttachments = async () => {
        const { images, videos, documents } = this.state;

        const image_attachments = await this.uploadAttachments(images, "work-requisitions/images", "image");
        const video_attachments = await this.uploadAttachments(videos, "work-requisitions/videos", "video");
        const document_attachments = await this.uploadAttachments(documents, "work-requisitions/documents", "document");

        if (image_attachments === null || video_attachments === null || document_attachments === null) return null;

        return [...image_attachments, ...video_attachments, ...document_attachments];
    };

    // -----------------------------------
    // Drag and Drop Handlers
    // -----------------------------------
    handleDragOver = (e) => {
        e.preventDefault();
    };

    handleImageDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const files = Array.from(e.dataTransfer.files);
            e.dataTransfer.clearData();
            this.addFiles(files, "image");
        }
    };

    handleVideoDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const files = Array.from(e.dataTransfer.files);
            e.dataTransfer.clearData();
            this.addFiles(files, "video");
        }
    };

    handleDocumentDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const files = Array.from(e.dataTransfer.files);
            e.dataTransfer.clearData();
            this.addFiles(files, "document");
        }
    };

    removeImage = async (index) => {
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        this.setState((prevState) => {
            let imgs = [...prevState.images];
            const [removed] = imgs.splice(index, 1);
            if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
            if (removed?.preview_url && removed.preview_url.startsWith("blob:")) URL.revokeObjectURL(removed.preview_url);
            return { images: imgs };
        });
    };

    removeVideo = async (index) => {
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        this.setState((prevState) => {
            let vids = [...prevState.videos];
            const [removed] = vids.splice(index, 1);
            if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
            if (removed?.preview_url && removed.preview_url.startsWith("blob:")) URL.revokeObjectURL(removed.preview_url);
            return { videos: vids };
        });
    };

    // เอกสารลบได้เฉพาะคนที่แนบไฟล์นั้นเท่านั้น (ไฟล์ที่เพิ่งเลือกในเซสชันนี้ยังไม่ได้บันทึก ถือเป็นของผู้ใช้ปัจจุบันเสมอ)
    isOwnDocument = (doc) => {
        if (!doc?.is_uploaded) return true;
        return !!doc?.created_by_uid && doc.created_by_uid === profile?.uid;
    };

    removeDocument = async (index) => {
        const doc = this.state.documents?.[index];
        if (!this.isOwnDocument(doc)) return;
        if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
        this.setState((prevState) => {
            let docs = [...prevState.documents];
            const [removed] = docs.splice(index, 1);
            if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
            return { documents: docs };
        });
    };

    // -----------------------------------
    // Helpers
    // -----------------------------------
    getPriorityStyle = (priorityName) => {
        const p = String(priorityName).toUpperCase();
        if (p.includes("EMERGENCY")) return { backgroundColor: "#dc3545", color: "#fff" };
        if (p.includes("HIGH")) return { backgroundColor: "#fd7e14", color: "#fff" };
        if (p.includes("MEDIUM")) return { backgroundColor: "#ffc107", color: "#fff" };
        return { backgroundColor: "#0d6efd", color: "#fff" };
    };

    getCategoryClass = (categoryName) => {
        const c = String(categoryName);
        if (c.includes("Corrective")) return "bg-secondary-light text-secondary";
        if (c.includes("Preventive")) return "bg-success-light text-success";
        return "bg-primary-light text-primary";
    };

    openViewModal = (request) => {
        this.openDetailModal(request);
    };

    // ปิดงาน: ใช้หน้าตาเดียวกับโหมดดูข้อมูล แล้วเพิ่มปุ่มปิดงานท้ายฟอร์ม
    openCloseJobModal = (request) => this.openDetailModal(request, { closeJobMode: true });

    // แก้ไขคำร้อง: modal เดียวกับดูข้อมูล แต่ปลด read-only ให้แก้ได้ (เปิดได้เฉพาะใบสถานะ pending)
    openEditModal = (request) => this.openDetailModal(request, { viewMode: false });

    // เปิด modal เดียวกับ create แต่ค่าเริ่มต้นเป็นโหมดดูอย่างเดียว (read-only) พร้อม preview ไฟล์แนบ
    openDetailModal = async (request, { closeJobMode = false, viewMode = true } = {}) => {
        loading(true);
        // ฟอร์มรายละเอียดอ่าน dropdown (แผนก/หมวด/ช่าง ฯลฯ) ตอน map ข้อมูล ต้องให้ master data มาก่อน
        const [result] = await Promise.all([GET("admin/work-requisitions", { uid: request?.uid }), this.optionsReady]);
        loading(false);

        if (result?.status !== true || !result?.data) {
            alert("", "warning", t("warning"), result?.message || t("no_data_found"));
            return;
        }

        const d = result.data;
        const attachments = Array.isArray(d.attachments) ? d.attachments : [];
        const toItem = (a) => ({
            uid: a.uid,
            name: a.file_name || "",
            url: a.file_path,
            file_type: a.file_type,
            mime_type: a.mime_type,
            file_size: a.file_size,
            is_uploaded: true,
            // ผู้แนบไฟล์ (ใช้เช็คสิทธิ์ "ลบได้เฉพาะคนอัปโหลด" ของเอกสาร - ดู isOwnDocument)
            created_by_uid: a.created_by_user?.uid || null,
            created_by_label: a.created_by_user?.department
                ? `${a.created_by_user.department.department_code || ""} ${a.created_by_user.department.name || ""}`.trim()
                : a.created_by_user?.full_name || null,
        });

        const matchedPriority = this.state.data_priorities.find((p) => p.uid === d.priority?.uid);

        // dropdown ลูกค้าโหลดตอนค้นหาเท่านั้น จึงต้อง seed ลูกค้าของใบนี้เข้าไปให้ Select แสดง label ได้
        const customerOption = d.customer ? this.toCustomerOption(d.customer) : null;

        // ทรัพย์สินโหลดเฉพาะของลูกค้ารายนี้ (มี location_name / warranty ที่คำนวณไว้แล้ว)
        // เพราะ asset ใน response ของ work-requisition ไม่มีฟิลด์เหล่านั้น
        const customerAssets = await this.loadCustomerAssets(d.customer?.uid || "");
        const selectedAsset = customerAssets.find((a) => a.uid === d.asset?.uid) || d.asset || null;

        // รูป/วิดีโอต้อง preview ทันทีที่เปิดฟอร์ม โหลด blob url ผ่าน endpoint ใหม่ให้เสร็จก่อน setState
        // (เอกสารไม่ preload เพราะจำนวนไม่จำกัด โหลดตอนกดดูแทน - ดู openDocument)
        const attachmentImages = attachments.filter((a) => a.file_type === "image").map(toItem);
        const attachmentVideos = attachments.filter((a) => a.file_type === "video").map(toItem);
        await Promise.all([this.hydratePreviewUrls(attachmentImages), this.hydratePreviewUrls(attachmentVideos)]);

        this.setState({
            modal_create: true,
            view_mode: viewMode || !can("wr.update"),
            close_job_mode: closeJobMode,
            uid: d.uid,
            active_request: d,
            data_customer: customerOption ? [customerOption] : [],
            create_customer_id: d.customer?.uid || "",
            create_customer_label: customerOption?.label || "",
            create_project_id: this.getAssetProjectId(selectedAsset) || PROJECT_UNSPECIFIED,
            create_asset_id: d.asset?.uid || "",
            select_asset: selectedAsset,
            create_contact_name_1: d.contact_name_1 || "",
            create_contact_phone_1: d.contact_phone_1 || "",
            create_contact_name_2: d.contact_name_2 || "",
            create_contact_phone_2: d.contact_phone_2 || "",
            create_contact_email: d.contact_email || "",
            create_category_id: d.category?.uid || "",
            create_service_type_id: d.service_type?.uid || this.getDefaultServiceTypeId(),
            create_problem_desc: d.problem_description || "",
            create_priority_id: d.priority?.uid || "",
            text_priority_id: this.getPriorityDescription(matchedPriority),
            create_internal_note: d.internal_remark || "",
            create_channel: d.channel || "call",
            create_no_parts: !!d.no_parts_requisition,
            create_parts_required_date: d.parts_required_date ? String(d.parts_required_date).slice(0, 10) : "",
            create_parts: (Array.isArray(d.parts) ? d.parts : []).map((part) => ({
                key: part.uid,
                uid: part.uid,
                part_id: part.part_id || "",
                part_number: part.part_number || "-",
                part_name: part.part_name || "-",
                uom_name: part.uom_name || "",
                quantity: part.quantity ?? 0,
            })),
            create_part_id: "",
            create_assigned_department_id: d.assigned_department?.uid || "",
            create_next_document_type: d.next_document_type || "",
            images: attachmentImages,
            videos: attachmentVideos,
            documents: attachments.filter((a) => a.file_type === "document").map(toItem),
        });
    };
    openFastCallModal = (request) => {
        const defaultTechnicianId = "";
        this.setState({
            modal_fast_call: true,
            fast_call_view_mode: false,
            active_request: request,
            ...this.getFastCallFormState(),
            fast_call_technician: defaultTechnicianId,
        });
    };

    openViewFastCallModal = async (request) => {
        loading(true);
        const result = await GET("admin/work-requisitions", { uid: request?.uid });
        loading(false);

        if (result?.status !== true || !result?.data) {
            alert("", "warning", t("warning"), result?.message || t("no_data_found"));
            return;
        }

        const requestDetail = result.data;
        const callData = requestDetail?.fast_call || requestDetail?.call || requestDetail?.work_requisition_call || requestDetail?.latest_call;

        if (!callData) {
            alert("", "warning", t("warning"), t("no_data_found"));
            return;
        }

        const normalizedCallTime = String(callData?.call_time || "").replace(" ", "T").slice(0, 16);

        this.setState({
            modal_fast_call: true,
            fast_call_view_mode: true,
            active_request: requestDetail,
            fast_call_technician: callData?.technician_id || callData?.technician?.uid || "",
            fast_call_date: normalizedCallTime.slice(0, 10),
            fast_call_time: normalizedCallTime.slice(11, 16),
            fast_call_duration: callData?.call_duration || 0,
            fast_call_channel: callData?.call_channel || "โทรศัพท์ตรง",
            fast_call_symptom: callData?.detail_from_customer || "",
            fast_call_guidance: callData?.detail_solution || "",
            fast_call_result: callData?.status === "success" ? "closed" : "visit",
        });
    };
    openApproveModal = (request) => {
        this.setState(
            {
                active_request: request,
            },
            () => {
                this.SubmitApprove();
            }
        );
        //     const { data_priorities } = this.state;
        //     let i = data_priorities.find(e=>e.uid === request.priority?.uid);
        //     this.setState({
        //       modal_approve: true,
        //       active_request: request,
        //       create_category_id: request.category?.uid,
        //       create_service_type_id: request.service_type?.uid,
        //       create_priority_id: request.priority?.uid,
        //       text_priority_id: `${i.name_th} - ต้องตอบสนองภายใน ${i.sla_response_time_start} - ${i.sla_response_time_end} ${i.sla_response_time_start_unit}`
        //     });
    };

    getStatusBadgeClass = (status) => {
        const statusKey = (status || "").toLowerCase();

        if (statusKey === "draft") {
            return "bg-light text-secondary border border-secondary";
        }
        if (statusKey === "pending") {
            return "bg-warning-light text-warning border border-warning";
        }
        if (statusKey === "pending_approval") {
            return "";
        }
        if (statusKey === "approved") {
            return "bg-info-light text-info border border-info";
        }
        if (statusKey === "success") {
            return "bg-success-light text-success border border-success";
        }
        if (statusKey === "cancel" || statusKey === "cancelled" || statusKey === "rejected") {
            return "bg-secondary-light text-secondary border border-secondary";
        }

        return "bg-light text-dark border";
    };

    openRejectModal = (request) => {
        this.setState({
            modal_reject: true,
            reject_view_mode: false,
            active_request: request,
            reject_reason_id: "",
            reject_note: "",
        });
    };

    openWorkOrderPage = (request) => {
        const workOrderNumber = request?.work_order?.wo_number || "";

        if (!workOrderNumber) {
            alert("", "warning", t("warning"), t("no_data_found"));
            return;
        }

        const queryParams = new URLSearchParams();
        queryParams.set("search", workOrderNumber);

        window.location.href = `/ad/work-orders?${queryParams.toString()}`;
    };

    viewRejectReason = (request) => {
        const rejectReasonId =
            request?.reject_reason?.uid ||
            request?.work_requisition_reject_reason?.uid ||
            request?.work_requisition_reject_reasons_id ||
            "";
        const rejectDescription = request?.reject_description || request?.reject_note || "";

        this.setState({
            modal_reject: true,
            reject_view_mode: true,
            active_request: request,
            reject_reason_id: rejectReasonId,
            reject_note: rejectDescription,
        });
    };

    openCreateModal = () => {
        this.setState({
            modal_create: true,
            ...this.getCreateFormState(),
        });
    };

    submitFastCall = async () => {
        const {
            company_id,
            active_request,
            fast_call_technician,
            fast_call_date,
            fast_call_time,
            fast_call_duration,
            fast_call_channel,
            fast_call_symptom,
            fast_call_guidance,
            fast_call_result,
            page,
        } = this.state;

        if (!fast_call_result) {
            alert("", "warning", t("warning"), t("call_result_required"));
            return;
        }

        if (!fast_call_technician || !active_request?.uid || !fast_call_date || !fast_call_time || fast_call_guidance === "") {
            alert("", "warning", t("warning"), t("required_fields"));
            return;
        }

        if (fast_call_guidance.trim().length < 30) {
            alert("", "warning", t("warning"), t("validate_solution_guidance_min_length"));
            return;
        }

        if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) {
            return;
        }

        loading(true);

        const body = {
            company_id: company_id,
            wr_id: active_request.uid,
            technician_id: fast_call_technician,
            call_time: fast_call_date && fast_call_time ? `${fast_call_date} ${fast_call_time}` : "",
            call_duration: Number(fast_call_duration),
            call_channel: fast_call_channel,
            detail_from_customer: fast_call_symptom,
            detail_solution: fast_call_guidance,
            // ผลลัพธ์ "ต้องเข้าหน้างาน" คงสถานะ pending ไว้ (ตัดขั้นตอนรออนุมัติออกแล้ว) แอดมินไปกดปิดงาน → สร้าง WO ต่อเอง
            status: fast_call_result === "closed" ? "success" : "pending",
            is_active: true,
        };

        const result = await POST("admin/work-requisition/calls", body);

        if (result?.status === true) {
            this.setState({
                modal_fast_call: false,
                active_request: null,
                ...this.getFastCallFormState(),
            });
            await this.Get(page);
            await alert("#", "success");
        } else {
            alert("", "warning", t("warning"), result?.message || t("error_occurred"));
        }

        loading(false);
    };

    render() {
        const {
            uid,
            data,
            count,
            filter_search,
            tab,
            modal_approve,
            modal_fast_call,
            fast_call_view_mode,
            active_request,
            technicians,
            wo_type,
            wo_priority,
            sla_template,
            modal_reject,
            modal_return,
            return_reason,
            reject_view_mode,
            reject_reason_id,
            reject_note,
            fast_call_technician,
            fast_call_date,
            fast_call_time,
            fast_call_duration,
            fast_call_channel,
            fast_call_symptom,
            fast_call_guidance,
            fast_call_result,
            select_asset,
            modal_create,
            view_mode,
            close_job_mode,
            create_customer_id,
            create_customer_label,
            create_project_id,
            create_asset_id,
            create_contact_name_1,
            create_contact_phone_1,
            create_contact_name_2,
            create_contact_phone_2,
            create_contact_email,
            create_category_id,
            create_service_type_id,
            create_problem_desc,
            create_priority_id,
            create_internal_note,
            create_no_parts,
            create_parts_required_date,
            create_parts,
            create_part_id,
            create_assigned_department_id,
            create_next_document_type,
            images,
            videos,
            documents,
            data_parts,
            data_departments,
            data_categories,
            data_priorities,
            data_reject_reasons,
            data_service_types,
            data_technicians,
            data_customer,
            text_priority_id,
            summary_count,
        } = this.state;

        const fastCallTechnicianOptions =
            Array.isArray(data_technicians) && data_technicians.length > 0
                ? activeOptions(data_technicians, fast_call_technician, { isActive: isTechnicianActive }).map((technician) => ({
                      value: technician.uid,
                      label: this.getTechnicianDisplayName(technician),
                  }))
                : [];
        const closeJobDocumentType = NEXT_DOCUMENT_TYPES.find((docType) => docType.value === create_next_document_type) || null;
        // process ของใบคำร้องมาจากหมวดหมู่ที่เลือก ไม่ได้กรอกเอง
        const selectedCategory = data_categories.find((item) => item.value === create_category_id || item.uid === create_category_id) || null;
        const selectedProcessView = PROCESS_NAME_VIEWS[selectedCategory?.process_name] || null;
        // หมวดหมู่ปิดเบิกอะไหล่: ใบเดิมที่มีอะไหล่แล้วแสดงอ่านอย่างเดียว / ใบอื่นติ๊ก "ไม่เบิกอะไหล่" ค้างและแก้ไม่ได้
        const partsClosed = selectedCategory?.enable_parts_requisition === false;
        const partsReadOnly = partsClosed && create_parts.length > 0;
        // ปิดงานได้ต่อเมื่อข้อมูลบังคับ (*) ครบ โดยเฉพาะแผนกที่รับผิดชอบและประเภทเอกสารถัดไป
        // ถ้ายังขาด ให้ disable ปุ่มปิดงานไว้ก่อน แล้วบอกว่าขาดอะไร (ต้องกลับไปแก้ที่ใบคำร้อง)
        const closeJobMissingFields = close_job_mode ? this.getMissingRequiredFields() : [];
        const canCloseJob = closeJobMissingFields.length === 0;
        const projectOptions = this.getProjectOptions();
        const filteredAssetOptions = this.getFilteredAssetOptions();

        return (
            <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
                <NavbarAdmin />
                <div className="body p-4 mt-3">
                    {/* Header Section */}
                    <div className="mb-4">
                        <h3 className="fw-bold mb-1">{t("work_requests")}</h3>
                        <div className="text-secondary">{t("manage_incoming_service_requests")}</div>
                    </div>

                    {/* Top Filter Toolbar */}
                    <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div className="d-flex flex-wrap gap-2 flex-grow-1">
                                {/* ค้นหาเฉพาะใบแจ้งงานในเมนูนี้ (ครอบคลุมเลขที่ / ลูกค้า / ทรัพย์สิน / S-N / part master / ผู้ติดต่อ / หมวด ฯลฯ)
                                    Enter = กรองตาราง, เลือกจาก dropdown = เติมเลขที่แล้วกรองบนแท็บ "ทั้งหมด" เพราะใบที่เลือกอาจไม่อยู่แท็บปัจจุบัน
                                    ทั้งสองทางสลับ "งานของฉัน" -> "ทั้งหมด" ให้เอง (searchWithScopeAll) */}
                                <GlobalSearchBox
                                    scope="work_requisition"
                                    value={filter_search}
                                    onChange={(value) => this.setState({ filter_search: value })}
                                    onEnter={() => this.searchWithScopeAll()}
                                    onSelect={() => this.searchWithScopeAll("all")}
                                    placeholder={t("search_work_requests_placeholder")}
                                />
                                {/* ISS-030: สลับดูเฉพาะงานของฉัน / ทั้งหมด (ค่าเริ่มต้น = งานของฉัน) */}
                                {/* สไตล์ pill ชุดเดียวกับแท็บสลับมุมมอง (รายการ/คัมบังบอร์ด/ปฏิทิน)
                                    ใช้พื้น bg-light เพราะกล่องฟิลเตอร์นี้เป็นพื้นขาว ถ้าใช้พื้นขาวด้วยจะกลืนจนไม่เห็นกรอบ */}
                                <div className="btn-group bg-light p-1 rounded-3 border" role="group">
                                    {[
                                        { key: "mine", label: t("scope_mine"), icon: "\uf007" },
                                        { key: "all", label: t("scope_all"), icon: "\uf0c9" },
                                    ].map((option) => (
                                        <button
                                            key={option.key}
                                            type="button"
                                            className={`btn btn-sm rounded-2 px-3 fw-bold text-nowrap d-flex align-items-center border-0 ${
                                                this.state.filter_scope === option.key ? "btn-primary" : "btn-white text-secondary bg-transparent"
                                            }`}
                                            onClick={() => this.changeScope(option.key)}
                                        >
                                            <span className="icon me-2">{option.icon}</span> {option.label}
                                        </button>
                                    ))}
                                </div>

                                <div className="d-flex gap-2">
                                    <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.searchWithScopeAll()}>
                                        {t("filter")}
                                    </button>
                                    <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.setState({ filter_search: "" }, () => this.Get(1))}>
                                        {t("clear_all")}
                                    </button>
                                </div>
                                {/* Filters */}
                            </div>
                            <div className="d-flex gap-2">
                                {can("wr.create") ? (
                                <button className="btn btn-primary px-3 fw-bold rounded-3 shadow-sm" onClick={this.openCreateModal}>
                                    <span className="me-2">+</span>
                                    {t("create_request")}
                                </button>
                                ) : null}
                            </div>
                        </div>
                    </div>

                    {/* Tabs Section */}
                    <div className="d-flex border-bottom mb-3 px-2 text-14">
                        <div
                            className={`py-3 px-3 ${tab === "all" ? "fw-bold text-primary" : "text-secondary"} pointer`}
                            style={{ borderBottom: tab === "all" ? "3px #1976D2 solid" : "" }}
                            onClick={() => {
                                this.Get(1, "all");
                            }}
                        >
                            {t("all_requests")} <span className="badge bg-danger rounded-pill ms-1 px-2">{formatNumber(summary_count.all)}</span>
                        </div>
                        <div
                            className={`py-3 px-3 ${tab === "draft" ? "fw-bold text-primary" : "text-secondary"} pointer`}
                            style={{ borderBottom: tab === "draft" ? "3px #1976D2 solid" : "" }}
                            onClick={() => {
                                this.Get(1, "draft");
                            }}
                        >
                            {t("draft")}{" "}
                            <span className="badge rounded-pill ms-1 px-2 text-white" style={{ backgroundColor: "#6B7280" }}>
                                {formatNumber(summary_count.draft || 0)}
                            </span>
                        </div>
                        <div
                            className={`py-3 px-3 ${tab === "pending" ? "fw-bold text-primary" : "text-secondary"} pointer`}
                            style={{ borderBottom: tab === "pending" ? "3px #1976D2 solid" : "" }}
                            onClick={() => {
                                this.Get(1, "pending");
                            }}
                        >
                            {t("pending")}{" "}
                            <span className="badge rounded-pill ms-1 px-2 text-dark" style={{ backgroundColor: "#FFE58F" }}>
                                {formatNumber(summary_count.pending)}
                            </span>
                        </div>
                        <div
                            className={`py-3 px-3 ${tab === "success" ? "fw-bold text-primary" : "text-secondary"} pointer`}
                            style={{ borderBottom: tab === "success" ? "3px #1976D2 solid" : "" }}
                            onClick={() => {
                                this.Get(1, "success");
                            }}
                        >
                            {t("success")}{" "}
                            <span className="badge rounded-pill ms-1 px-2 text-white" style={{ backgroundColor: "#22C55E" }}>
                                {formatNumber((summary_count.success || 0) + (summary_count.approved || 0))}
                            </span>
                        </div>
                        <div
                            className={`py-3 px-3 ${tab === "rejected" ? "fw-bold text-primary" : "text-secondary"} pointer`}
                            style={{ borderBottom: tab === "rejected" ? "3px #1976D2 solid" : "" }}
                            onClick={() => {
                                this.Get(1, "rejected");
                            }}
                        >
                            {t("rejected")}{" "}
                            <span className="badge rounded-pill ms-1 px-2 text-white" style={{ backgroundColor: "#9CA3AF" }}>
                                {formatNumber(summary_count.rejected)}
                            </span>
                        </div>
                    </div>

                    {/* Table List Section */}
                    <div className="bg-white rounded-4 shadow-sm pb-2">
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0" style={{ minWidth: "1800px" }}>
                                <thead>
                                    <tr className="text-muted fw-bold text-12 border-bottom border-light text-uppercase">
                                        {/* <th className="px-3 pb-1 wpx-40">
                                            <input type="checkbox" className="form-check-input" />
                                        </th> */}
                                        <th className="py-3 border-0 wpx-150">{t("request_id")}</th>
                                        <th className="py-3 border-0 wpx-250">{t("customer_project_asset")}</th>
                                        <th className="py-3 border-0 wpx-300">{t("description")}</th>
                                        <th className="py-3 border-0 wpx-120">{t("wr_urgency_level")}</th>
                                        <th className="py-3 border-0 wpx-120">{t("category")}</th>
                                        {/* ISS-017: ตัดคอลัมน์ "ช่องทาง" และ "วันที่รับ" ออก ใส่ผู้สร้าง/ผู้อนุมัติแทน */}
                                        <th className="py-3 border-0 wpx-180">{t("primary_contact")}</th>
                                        <th className="py-3 border-0 wpx-180">{t("created_by_col")}</th>
                                        <th className="py-3 border-0 wpx-160">{t("creator_department")}</th>
                                        <th className="py-3 border-0 wpx-160">{t("responsible_department")}</th>
                                        <th className="py-3 border-0 wpx-180">{t("approved_by_col")}</th>
                                        <th className="py-3 border-0 wpx-180 ">{t("status")}</th>
                                        {/* ปุ่ม action ปักไว้ขวาสุด (sticky) ตารางกว้างกว่าจอ เลื่อนแล้วยังกดได้ทันที */}
                                        <th className="py-3 border-0 wpx-160 bg-white" style={STICKY_ACTION_STYLE}>
                                            {t("actions")}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index} className="border-bottom border-light bg-white">
                                            {/* <td className="px-3 py-2 rounded-start" style={{ borderLeft: `4px solid ${item.borderColor}` }}>
                                                <input type="checkbox" className="form-check-input" />
                                            </td> */}

                                            <td className="text-nowrap">
                                                <a href="#" className="text-primary text-12 fw-bold text-decoration-none" onClick={() => this.openViewModal(item)}>
                                                    {item.wr_number}
                                                </a>
                                            </td>

                                            {/* ลูกค้า / โครงการ / ทรัพย์สิน - โครงการมาจาก snapshot project_name ของทรัพย์สิน */}
                                            <td className="text-nowrap">
                                                <div className="fw-bold text-12 text-dark text-nowrap">{this.getCustomerDisplayName(item.customer)}</div>
                                                <div className="text-secondary text-12">{item.asset?.project_name || "-"}</div>
                                                <div className="text-secondary text-12">{item.asset?.part_name || "-"}</div>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="fw-bold text-12 text-dark text-wrap">
                                                    {String(item.problem_description || "").length > 40 ? `${String(item.problem_description || "").slice(0, 40)}...` : item.problem_description || "-"}
                                                </div>
                                                {item.attachments?.length > 0 && (
                                                    <div className="text-secondary text-12 mt-1">
                                                        <span className="text-12 icon me-1">{""}</span> {item.attachments.length}
                                                    </div>
                                                )}
                                            </td>

                                            <td className="text-nowrap">
                                                <span className="badge rounded-pill fw-normal px-2 py-1 text-12" style={this.getPriorityStyle(item.priority?.name_th)}>
                                                    {item.priority?.name_th || ""}
                                                </span>
                                            </td>

                                            <td className="text-nowrap">
                                                <div>
                                                    <span className={`badge rounded-pill fw-normal px-2 py-1 text-12 ${this.getCategoryClass(item.category?.name_th || "")}`}>
                                                        {item.category?.name_th || ""}
                                                    </span>
                                                </div>
                                                {/* บรรทัด 2: process ของใบนี้ (ค่ามาจากหมวดหมู่ที่เลือก) */}
                                                <div className="text-10 text-secondary mt-1">{PROCESS_NAME_VIEWS[item.process_name] ? t(PROCESS_NAME_VIEWS[item.process_name].labelKey) : "-"}</div>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="fw-bold text-dark text-12">{item.contact_name_1 || "-"}</div>
                                                <small className="text-secondary">{item.contact_phone_1 || "-"}</small>
                                            </td>

                                            {/* ISS-002 + ISS-017: ผู้สร้าง / ผู้อนุมัติ พร้อมเวลาที่ดำเนินการ */}
                                            <td className="text-nowrap">
                                                <div className="fw-bold text-dark text-12">{item.created_by_user?.full_name || "-"}</div>
                                                <div className="text-secondary text-12">{item.created_at ? format_date(item.created_at, "dd/mm/yyyy hh:mm", "th") : "-"}</div>
                                            </td>

                                            {/* แผนกต้นสังกัดของผู้สร้าง / แผนกที่รับมอบหมายงานต่อ */}
                                            <td className="text-nowrap">
                                                <div className="text-dark text-12">{item.created_by_user?.department?.department_code || "-"}</div>
                                                <div className="text-secondary text-12">{item.created_by_user?.department?.name || "-"}</div>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="text-dark text-12">{item.assigned_department?.department_code || "-"}</div>
                                                <div className="text-secondary text-12">{item.assigned_department?.name || "-"}</div>
                                            </td>

                                            <td className="text-nowrap">
                                                <div className="fw-bold text-dark text-12">{item.approved_by_user?.full_name || "-"}</div>
                                                <div className="text-secondary text-12">{item.approved_at ? format_date(item.approved_at, "dd/mm/yyyy hh:mm", "th") : "-"}</div>
                                            </td>

                                            <td className="text-nowrap">
                                                <span
                                                    className={`badge rounded-pill px-3 py-1 text-12 d-inline-flex align-items-center justify-content-center ${this.getStatusBadgeClass(item.status)}`}
                                                    style={item.status === "pending_approval" ? { backgroundColor: "#F3E8FF", color: "#7C3AED", border: "1px solid #C4B5FD" } : undefined}
                                                >
                                                    {item.status.replaceAll("_", " ").toUpperCase()}
                                                </span>
                                                {/* ใบที่ถูก Return มาเป็น draft พร้อมเหตุผล - ให้ผู้สร้างเห็นจากหน้า list ทันที */}
                                                {item.status === "draft" && item.reject_description ? (
                                                    <div className="text-danger text-12 mt-1 text-wrap" style={{ maxWidth: "170px" }} title={item.reject_description}>
                                                        {t("wr_returned_reason_label")}: {String(item.reject_description).length > 40 ? `${String(item.reject_description).slice(0, 40)}...` : item.reject_description}
                                                    </div>
                                                ) : null}
                                            </td>

                                            <td className="rounded-end text-start me-2 bg-white" style={STICKY_ACTION_STYLE}>
                                                <div className="d-flex align-items-center gap-2 justify-content-start pe-3">
                                                    <ActionIconButton
                                                        label={t("view")}
                                                        icon={ACTION_ICONS.view}
                                                        variant="primary"
                                                        onClick={() => this.openDetailModal(item)}
                                                    />
                                                    {item.status === "draft" ? (
                                                        // แบบร่าง: เห็นเฉพาะผู้สร้าง/super_user - แก้ไขแล้วส่งใหม่ได้
                                                        can("wr.update") ? (
                                                        <ActionIconButton
                                                            label={t("edit")}
                                                            icon={ACTION_ICONS.edit}
                                                            variant="warning"
                                                            onClick={() => this.openEditModal(item)}
                                                        />
                                                        ) : null
                                                    ) : item.status === "pending" ? (
                                                        <div className="d-flex align-items-center gap-2 justify-content-start pe-3">
                                                            {/* แก้ไขได้เฉพาะใบที่ยังรอดำเนินการ ใบที่ส่งอนุมัติ/ปิดงานแล้วห้ามแก้
                                                                และแผนกที่ถูกส่งมอบงานต่อ (can_edit=false ตาม assigned_department) ดูได้อย่างเดียว - ไม่มีปุ่มแก้ไข */}
                                                            {item.can_edit !== false && can("wr.update") && (
                                                                <ActionIconButton
                                                                    label={t("edit")}
                                                                    icon={ACTION_ICONS.edit}
                                                                    variant="warning"
                                                                    onClick={() => this.openEditModal(item)}
                                                                />
                                                            )}
                                                            {can("wr.update") ? (
                                                            <ActionIconButton
                                                                label={t("close_job")}
                                                                icon={ACTION_ICONS.check}
                                                                variant="success"
                                                                onClick={() => this.openCloseJobModal(item)}
                                                            />
                                                            ) : null}
                                                            {can("wr.update") ? (
                                                            <ActionIconButton
                                                                label={t("wr_return")}
                                                                icon={RETURN_ICON}
                                                                variant="secondary"
                                                                onClick={() => this.openReturnModal(item)}
                                                            />
                                                            ) : null}
                                                            {can("wr.update") ? (
                                                            <ActionIconButton
                                                                label={t("reject")}
                                                                icon={ACTION_ICONS.close}
                                                                variant="danger"
                                                                onClick={() => this.openRejectModal(item)}
                                                            />
                                                            ) : null}
                                                        </div>
                                                    ) : item.status === "pending_approval" ? (
                                                        <div className="d-flex align-items-center gap-2 justify-content-start">
                                                            {can("wr.update") ? (
                                                            <ActionIconButton
                                                                label={t("approve")}
                                                                icon={ACTION_ICONS.check}
                                                                variant="success"
                                                                onClick={() => this.openApproveModal(item)}
                                                            />
                                                            ) : null}
                                                            {can("wr.update") ? (
                                                            <ActionIconButton
                                                                label={t("wr_return")}
                                                                icon={RETURN_ICON}
                                                                variant="secondary"
                                                                onClick={() => this.openReturnModal(item)}
                                                            />
                                                            ) : null}
                                                            {can("wr.update") ? (
                                                            <ActionIconButton
                                                                label={t("reject")}
                                                                icon={ACTION_ICONS.close}
                                                                variant="danger"
                                                                onClick={() => this.openRejectModal(item)}
                                                            />
                                                            ) : null}
                                                        </div>
                                                    ) : item.status === "approved" ? (
                                                        <ActionIconButton
                                                            label={t("view_wo")}
                                                            icon={ACTION_ICONS.view}
                                                            variant="info"
                                                            onClick={() => this.openWorkOrderPage(item)}
                                                        />
                                                    ) : item.status === "success" ? (
                                                        // ใบที่ปิดงานจากปุ่ม "ปิดงาน" ไม่มีข้อมูลโทรด่วน จึงโชว์ปุ่มนี้เฉพาะใบที่มีจริง
                                                        item.fast_call ? (
                                                            <ActionIconButton
                                                                label={t("view_fast_call")}
                                                                icon={ACTION_ICONS.phone}
                                                                variant="success"
                                                                onClick={() => this.openViewFastCallModal(item)}
                                                            />
                                                        ) : null
                                                    ) : item.status === "rejected" ? (
                                                        <div className="d-flex align-items-center gap-2 justify-content-start">
                                                            <ActionIconButton
                                                                label={t("view_reason")}
                                                                icon={ACTION_ICONS.view}
                                                                variant="secondary"
                                                                onClick={() => this.viewRejectReason(item)}
                                                            />
                                                            {item.fast_call ? (
                                                                <ActionIconButton
                                                                    label={t("view_fast_call")}
                                                                    icon={ACTION_ICONS.phone}
                                                                    variant="secondary"
                                                                    onClick={() => this.openViewFastCallModal(item)}
                                                                />
                                                            ) : null}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
                        <Pagination count={Math.ceil(count / this.state.page_size) || 1} page={this.state.page} onChange={(_, page) => this.Get(page)} />
                    </div>
                </div>

                {/* ===================== CREATE WORK REQUEST MODAL ===================== */}
                <Modal
                    size="lg"
                    show={modal_create}
                    onHide={() => this.setState({ modal_create: false, ...this.getCreateFormState() })}
                    centered
                    contentClassName="border-0 rounded-4 overflow-hidden shadow-lg bg-light"
                >
                    <Modal.Header className="bg-white border-bottom px-4 py-3 d-flex justify-content-between align-items-center" closeButton>
                        <div>
                            <h5 className="fw-bold mb-1 text-dark d-flex align-items-center">
                                <span className="icon me-2 text-secondary">{"\uf0ea"}</span>{" "}
                                {close_job_mode
                                    ? `${t("close_job")} ${active_request?.wr_number || ""}`.trim()
                                    : view_mode
                                      ? `${t("view")} ${active_request?.wr_number || ""}`.trim()
                                      : uid
                                        ? `${t("edit_work_request")} ${active_request?.wr_number || ""}`.trim()
                                        : t("create_work_request")}
                            </h5>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="p-4" style={{ maxHeight: "75vh", overflowY: "auto", backgroundColor: "#F8F9FA" }}>
                        {/* ใบที่ถูก Return มา (draft + เหตุผล) - แสดงเหตุผลให้ผู้สร้างเห็นขณะแก้ไข */}
                        {active_request?.status === "draft" && active_request?.reject_description ? (
                            <div className="alert alert-danger text-14 mb-3" style={{ whiteSpace: "pre-wrap" }}>
                                <span className="icon me-2">{"\uf071"}</span>
                                <span className="fw-bold">{t("wr_returned_reason_banner")}:</span> {active_request.reject_description}
                            </div>
                        ) : null}
                        <fieldset disabled={view_mode} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
                            {/* Section 1: ข้อมูลลูกค้าและเครื่อง */}
                            <div className="mb-4">
                                <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                    <span className="icon me-2 text-16">{"\uf007"}</span>
                                    {t("customer_asset_info")}
                                </h6>
                                <div className="bg-white rounded-3 p-3 border ">
                                    <div className="row g-3">
                                        <div className="col-md-12">
                                            <label className="form-label text-dark fw-bold text-14">
                                                {t("customer")} <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                className="form-control"
                                                options={data_customer}
                                                onSearch={this.searchCustomers}
                                                valueLabel={create_customer_label}
                                                onChange={(e, i) => {
                                                    // ความสำคัญจากลูกค้าใช้เป็นค่าตั้งต้นเท่านั้น ผู้ใช้แก้เองได้ที่หัวข้อความสำคัญ
                                                    const customerPriorityId = i?.priority?.uid || i?.priority_id || "";
                                                    const matchedPriority = this.state.data_priorities.find((priority) => priority.uid === customerPriorityId || priority.value === customerPriorityId);

                                                    this.setState({
                                                        create_customer_id: e,
                                                        create_customer_label: e ? i?.label || "" : "",
                                                        create_contact_name_1: ((i?.contact_first_name || "") + " " + (i?.contact_last_name || "")).trim(),
                                                        create_contact_phone_1: i?.contact_phone || "",
                                                        create_contact_email: i?.contact_email || "",
                                                        create_priority_id: customerPriorityId,
                                                        text_priority_id: this.getPriorityDescription(matchedPriority),
                                                        create_project_id: "",
                                                        create_asset_id: "",
                                                        select_asset: null,
                                                    });

                                                    // ทรัพย์สินของลูกค้ารายนี้เท่านั้น (เป็นฐานของตัวเลือกโครงการด้วย)
                                                    this.loadCustomerAssets(e);
                                                }}
                                                value={create_customer_id}
                                                placeholder={t("select_customer")}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <label className="form-label text-dark fw-bold text-14">
                                                {t("label_project")} <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                className="form-control"
                                                options={projectOptions}
                                                onChange={(e) => {
                                                    // เปลี่ยนโครงการแล้วต้องล้างทรัพย์สินเดิม เพราะรายการทรัพย์สินถูกกรองตามโครงการ
                                                    this.setState({ create_project_id: e, create_asset_id: "", select_asset: null });
                                                }}
                                                value={create_project_id}
                                                placeholder={t("placeholder_select_project")}
                                                disabled={!create_customer_id}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <label className="form-label text-dark fw-bold text-14">
                                                {t("asset")} <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                className="form-control"
                                                options={filteredAssetOptions}
                                                onChange={(e, i) => {
                                                    this.setState({ create_asset_id: e, select_asset: i });
                                                }}
                                                value={create_asset_id}
                                                placeholder={t("select_asset")}
                                                disabled={!create_project_id}
                                            />
                                        </div>
                                    </div>

                                    {/* Asset Info Box */}
                                    {select_asset && (
                                        <div className="mt-3 bg-primary-light rounded-3 p-3 border border-primary" style={{ backgroundColor: "#EBF3FF", borderColor: "#B3D4FF" }}>
                                            <div className="d-flex align-items-start gap-2 text-14">
                                                <span className="icon text-primary">{"\uf05a"}</span>
                                                <div className="text-primary">
                                                    <span className="fw-bold">Asset:</span> {this.getAssetDisplayName(select_asset)} <span className="mx-1">|</span>
                                                    <span className="fw-bold">Serial No.:</span> {select_asset?.serial_number} <span className="mx-1">|</span>
                                                    <span className="fw-bold">Warranty:</span>{" "}
                                                    {select_asset?.customer_warranty_expire_date ? (
                                                        // ป้ายสถานะประกัน: เขียว = อยู่ในประกัน / แดง = หมดประกัน
                                                        this.isWarrantyExpired(select_asset.customer_warranty_expire_date) ? (
                                                            <span className="badge rounded-pill bg-danger-light text-danger border border-status-danger fw-normal text-12 px-2 py-1 align-middle fw-bold">
                                                                <span className="icon me-1">{"\uf071"}</span>
                                                                {t("out_of_warranty")} ({t("warranty_until")} {format_date(select_asset.customer_warranty_expire_date, "dd/mm/yyyy", "th")})
                                                            </span>
                                                        ) : (
                                                            <span className="badge rounded-pill bg-success-light text-success border border-status-success fw-normal text-12 px-2 py-1 align-middle fw-bold">
                                                                <span className="icon me-1">{"\uf00c"}</span>
                                                                {t("under_warranty")} ({t("warranty_until")} {format_date(select_asset.customer_warranty_expire_date, "dd/mm/yyyy", "th")})
                                                            </span>
                                                        )
                                                    ) : (
                                                        "-"
                                                    )}{" "}
                                                    <span className="mx-1">|</span>
                                                    <span className="fw-bold">Location:</span> {this.getAssetLocationName(select_asset)}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Section 2: ข้อมูลผู้ติดต่อ */}
                            <div className="mb-4">
                                <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                    <span className="icon me-2 text-16">{"\uf095"}</span>
                                    {t("contact_info")}
                                </h6>
                                <div className="bg-white rounded-3 p-3 border ">
                                    <div className="row g-3">
                                        <div className="col-md-8">
                                            <label className="form-label text-dark fw-bold text-14">
                                                {t("primary_contact")} <span className="badge bg-light text-secondary fw-normal ms-1 border">{t("auto_from_customer")}</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control py-2 "
                                                placeholder={t("enter_primary_contact_name")}
                                                value={create_contact_name_1}
                                                onChange={(e) => this.setState({ create_contact_name_1: e.target.value })}
                                                disabled
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-white d-none d-md-block">&nbsp;</label>
                                            <input
                                                type="text"
                                                className="form-control py-2 "
                                                placeholder={t("enter_primary_contact_phone")}
                                                value={create_contact_phone_1}
                                                onChange={(e) => this.setState({ create_contact_phone_1: e.target.value })}
                                                disabled
                                            />
                                        </div>

                                        <div className="col-md-8 mt-3">
                                            <label className="form-label text-dark fw-bold text-14">{t("secondary_contact_optional")}</label>
                                            <input
                                                type="text"
                                                className="form-control py-2 "
                                                placeholder={t("enter_secondary_contact_name")}
                                                value={create_contact_name_2}
                                                onChange={(e) => this.setState({ create_contact_name_2: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-md-4 mt-md-3">
                                            <label className="form-label text-white d-none d-md-block">&nbsp;</label>
                                            <input
                                                type="text"
                                                className="form-control py-2 "
                                                placeholder={t("phone_number")}
                                                maxLength={10}
                                                value={create_contact_phone_2}
                                                onChange={(e) => {
                                                    if (!float(e.target.value)) return;
                                                    this.setState({ create_contact_phone_2: e.target.value });
                                                }}
                                            />
                                        </div>

                                        <div className="col-12 mt-3">
                                            <label className="form-label text-dark fw-bold text-14">{t("customer_email")}</label>
                                            {/* แก้ไขได้เฉพาะในคำร้องนี้ ไม่กระทบอีเมลในข้อมูลหลักของลูกค้า */}
                                            <input
                                                type="email"
                                                className="form-control py-2 "
                                                placeholder={t("customer_email")}
                                                maxLength={100}
                                                value={create_contact_email}
                                                onChange={(e) => this.setState({ create_contact_email: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Section 3: รายละเอียดปัญหา */}
                            <div className="mb-4">
                                <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                    <span className="icon me-2">{"\uf0ad"}</span>
                                    {t("problem_description")}
                                </h6>
                                <div className="bg-white rounded-3 p-3 border ">
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">
                                                {t("req_category")}
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="form-control"
                                                placeholder={t("select_req_category")}
                                                options={data_categories}
                                                onChange={(e, i) => this.setState(this.getCategoryChangeState(e, i))}
                                                value={create_category_id}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">
                                                {t("service_type")}
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="form-control"
                                                placeholder={t("select_service_type")}
                                                options={data_service_types}
                                                onChange={(e, i) => {
                                                    this.setState({ create_service_type_id: e });
                                                }}
                                                value={create_service_type_id}
                                            />
                                        </div>
                                        <div className="col-12 mt-3">
                                            <label className="form-label fw-bold">
                                                {t("problem_description")} <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                className="form-control "
                                                rows="3"
                                                placeholder={t("describe_problem_detail")}
                                                value={create_problem_desc}
                                                onChange={(e) => this.setState({ create_problem_desc: e.target.value })}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Section 4: ความสำคัญ */}
                            <div className="mb-4">
                                <h6 className="fw-bold text-secondary mb-3">
                                    <span className="icon me-2 text-warning">{"\uf0e7"}</span> {t("wr_urgency_level")}
                                    <span className="text-danger"> *</span>
                                </h6>
                                <div className="bg-white rounded-3 p-3 border">
                                    <div className="row g-3">
                                        <div className="col-12 col-lg-6">
                                            <Select
                                                className="form-control"
                                                placeholder={t("wr_select_urgency_level")}
                                                options={data_priorities}
                                                onChange={(e, i) => {
                                                    this.setState({
                                                        create_priority_id: e,
                                                        text_priority_id: this.getPriorityDescription(i),
                                                    });
                                                }}
                                                value={create_priority_id}
                                            />
                                        </div>
                                        <div className="col-12 col-lg-6">
                                            <input type="text" className="form-control" value={text_priority_id} placeholder={t("wr_urgency_level")} disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Section 5: ไฟล์แนบ (DRAG & DROP) */}
                            <div className="mb-4">
                                <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                    <span className="icon me-2 text-16">{"\uf0c6"}</span> {t("attachment_files")}
                                </h6>
                                <div className="bg-white rounded-3 p-3 border ">
                                    {/* Images Dropzone */}
                                    <label className="form-label text-dark fw-bold text-14 mb-2">
                                        {t("images")}{" "}
                                        <span className="text-secondary fw-normal">
                                            ({images.length}/{IMAGE_RULE.maxFiles})
                                        </span>
                                    </label>
                                    {!view_mode && (
                                        <div
                                            className="border rounded-3 p-4 mb-3 text-center pointer"
                                            style={{ borderStyle: "dashed", borderColor: "#ccc", backgroundColor: "#fafafa" }}
                                            onDragOver={this.handleDragOver}
                                            onDrop={this.handleImageDrop}
                                            onClick={() => document.getElementById("img-upload").click()}
                                        >
                                            <input
                                                type="file"
                                                id="img-upload"
                                                multiple
                                                accept="image/*"
                                                hidden
                                                onChange={(e) => {
                                                    const files = Array.from(e.target.files || []);
                                                    e.target.value = "";
                                                    this.addFiles(files, "image");
                                                }}
                                            />
                                            <span className="icon text-30 text-success mb-2 d-block">{"\uf03e"}</span>
                                            <div className="fw-bold text-dark text-14">{t("click_or_drag_image_here")}</div>
                                            <div className="text-12 text-secondary mt-1">{formatText(t("upload_hint_images"), { count: IMAGE_RULE.maxFiles, size: toMB(IMAGE_RULE.maxSize) })}</div>
                                        </div>
                                    )}

                                    {/* Preview Images */}
                                    <div className="d-flex flex-wrap gap-2 mb-4">
                                        {images.map((img, i) => (
                                            <div key={i} className="border rounded-3 p-2 text-center position-relative bg-light wpx-100">
                                                {!view_mode && (
                                                    <div
                                                        className="position-absolute top-0 end-0 bg-danger text-white rounded-circle wpx-15 hpx-15 d-flex align-items-center justify-content-center pointer"
                                                        style={{ transform: "translate(30%, -30%)", zIndex: 2 }}
                                                        onClick={() => this.removeImage(i)}
                                                    >
                                                        <span className="icon text-10">{"\uf00d"}</span>
                                                    </div>
                                                )}
                                                <a href={img.preview_url || img.url} target="_blank" rel="noopener noreferrer" download={img.name || undefined}>
                                                    <img src={img.preview_url || img.url} alt={img.name} className="rounded-2 mb-1" style={{ width: "100%", height: "70px", objectFit: "cover" }} />
                                                </a>
                                                <div className="text-10 text-secondary text-truncate" title={img.name}>
                                                    {img.name}
                                                </div>
                                                <div className="text-10 text-secondary">{formatFileSize(img.size ?? img.file_size)}</div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Videos Dropzone */}
                                    <label className="form-label text-dark fw-bold text-14 mb-2">
                                        {t("videos")}{" "}
                                        <span className="text-secondary fw-normal">
                                            ({videos.length}/{VIDEO_RULE.maxFiles})
                                        </span>
                                    </label>
                                    {!view_mode && (
                                        <div
                                            className="border rounded-3 p-4 mb-3 text-center pointer"
                                            style={{ borderStyle: "dashed", borderColor: "#fd7e14", backgroundColor: "#fff8f3" }}
                                            onDragOver={this.handleDragOver}
                                            onDrop={this.handleVideoDrop}
                                            onClick={() => document.getElementById("vid-upload").click()}
                                        >
                                            <input
                                                type="file"
                                                id="vid-upload"
                                                multiple
                                                accept="video/mp4,video/quicktime"
                                                hidden
                                                onChange={(e) => {
                                                    const files = Array.from(e.target.files || []);
                                                    e.target.value = "";
                                                    this.addFiles(files, "video");
                                                }}
                                            />
                                            <span className="icon text-30 text-dark mb-2 d-block">{"\uf03d"}</span>
                                            <div className="fw-bold text-dark text-14">{t("click_or_drag_video_here")}</div>
                                            <div className="text-12 text-secondary mt-1">{formatText(t("upload_hint_videos"), { count: VIDEO_RULE.maxFiles, size: toMB(VIDEO_RULE.maxSize) })}</div>
                                        </div>
                                    )}

                                    {/* Preview Videos */}
                                    <div className="d-flex flex-wrap gap-3 mb-3">
                                        {videos.map((vid, i) => (
                                            <div key={i} className="border rounded-3 p-2 position-relative bg-light" style={{ width: "200px" }}>
                                                {!view_mode && (
                                                    <div
                                                        className="position-absolute top-0 end-0 bg-danger text-white rounded-circle wpx-15 hpx-15 d-flex align-items-center justify-content-center pointer"
                                                        style={{ transform: "translate(30%, -30%)", zIndex: 2 }}
                                                        onClick={() => this.removeVideo(i)}
                                                    >
                                                        <span className="icon text-10">{"\uf00d"}</span>
                                                    </div>
                                                )}
                                                <video src={vid.preview_url || vid.url} controls className="rounded-2 mb-1 w-100 bg-dark" style={{ height: "110px", objectFit: "contain" }} />
                                                <div className="text-10 text-secondary text-truncate fw-bold" title={vid.name}>
                                                    {vid.name}
                                                </div>
                                                <div className="text-10 text-secondary">{formatFileSize(vid.size ?? vid.file_size)}</div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Documents Dropzone: unlimited reference document attachments (also usable during close_job_mode) */}
                                    <label className="form-label text-dark fw-bold text-14 mb-2 d-flex align-items-center flex-wrap">
                                        {t("documents")}
                                        <span className="badge rounded-pill fw-normal ms-2 text-10" style={{ backgroundColor: "#DCFCE7", color: "#15803D" }}>
                                            {t("new_badge")}
                                        </span>
                                        <span className="text-secondary fw-normal ms-2">({documents.length})</span>
                                        {/* คำใบ้ประเภทเอกสารถัดไป (เช่น Quotation) โชว์ทุกโหมด (สร้าง/แก้ไข/ปิดงาน) ไม่ใช่แค่ตอนปิดงาน ตามต้นแบบ */}
                                        {closeJobDocumentType && (
                                            <span className="text-11 text-secondary fw-normal ms-2">
                                                {formatText(t("documents_hint_for_doc_type"), { type: t(closeJobDocumentType.labelKey), code: closeJobDocumentType.caption })}
                                            </span>
                                        )}
                                    </label>
                                    {(!view_mode || close_job_mode) && (
                                        <div
                                            className="border rounded-3 p-4 mb-3 text-center pointer"
                                            style={{ borderStyle: "dashed", borderColor: "#2563EB", backgroundColor: "#EFF4FF" }}
                                            onDragOver={this.handleDragOver}
                                            onDrop={this.handleDocumentDrop}
                                            onClick={() => document.getElementById("doc-upload").click()}
                                        >
                                            <input
                                                type="file"
                                                id="doc-upload"
                                                multiple
                                                accept={DOCUMENT_FILE_ACCEPT}
                                                hidden
                                                onChange={(e) => {
                                                    const files = Array.from(e.target.files || []);
                                                    e.target.value = "";
                                                    this.addFiles(files, "document");
                                                }}
                                            />
                                            <span className="icon text-30 text-primary mb-2 d-block">{"\uf15c"}</span>
                                            <div className="fw-bold text-dark text-14">{t("click_or_drag_document_here")}</div>
                                            <div className="text-12 text-secondary mt-1">{formatText(t("upload_hint_documents"), { size: toMB(DOCUMENT_RULE.maxSize) })}</div>
                                        </div>
                                    )}

                                    {/* Preview Documents */}
                                    <div className="mb-1">
                                        {documents.map((doc, i) => {
                                            const isOwn = this.isOwnDocument(doc);
                                            const canManage = !view_mode || close_job_mode;
                                            return (
                                                <div key={i} className="d-flex align-items-center justify-content-between border rounded-3 p-2 mb-2 bg-light">
                                                    <div className="d-flex align-items-center gap-2 overflow-hidden">
                                                        <span className="icon text-16 text-primary">{"\uf15c"}</span>
                                                        <div className="overflow-hidden">
                                                            <a
                                                                href="#!"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.openDocument(doc);
                                                                }}
                                                                className="text-12 fw-bold text-dark text-truncate d-block text-decoration-none pointer"
                                                                title={doc.name}
                                                            >
                                                                {doc.name}
                                                            </a>
                                                            <div className="text-10 text-secondary">
                                                                {formatFileSize(doc.size ?? doc.file_size)}
                                                                {doc.created_by_label ? ` \u00b7 ${formatText(t("uploaded_by_label"), { name: doc.created_by_label })}` : ""}
                                                                {doc.is_uploaded && isOwn && (
                                                                    <span className="badge bg-success-light text-success fw-normal ms-2 text-10">{t("your_file")}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {canManage &&
                                                        (isOwn ? (
                                                            <span className="icon text-danger pointer text-14 ms-2" onClick={() => this.removeDocument(i)}>
                                                                {"\uf2ed"}
                                                            </span>
                                                        ) : (
                                                            <span className="icon text-secondary text-14 ms-2" title={t("attachment_locked_hint")}>
                                                                {"\uf023"}
                                                            </span>
                                                        ))}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>

                            <div className="mb-4">
                                <h6 className="fw-bold text-secondary mb-3">
                                    <span className="icon me-2">{"\uf044"}</span> {t("admin_internal_note")}
                                </h6>
                                <textarea
                                    className="form-control  text-14"
                                    rows="3"
                                    placeholder={t("internal_notes")}
                                    value={create_internal_note}
                                    onChange={(e) => this.setState({ create_internal_note: e.target.value })}
                                ></textarea>
                            </div>

                            {/* Section 7: ขอเบิกอะไหล่ (ไม่บังคับ) */}
                            <div className="mb-4">
                                <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                    <span className="icon me-2 text-16" style={{ color: "#D97706" }}>
                                        {"\uf466"}
                                    </span>
                                    {t("parts_requisition")}
                                    <span className="badge fw-normal ms-2 border text-11" style={{ backgroundColor: "#FFF4E5", color: "#B45309", borderColor: "#FBD9A5" }}>
                                        {t("optional")}
                                    </span>
                                </h6>
                                <div className="rounded-3 p-3 border" style={{ borderStyle: "dashed", borderColor: "#FBD9A5", backgroundColor: "#FFF9F0" }}>
                                    {view_mode || partsReadOnly ? (
                                        /* โหมดดูข้อมูล: สรุปเป็นตารางอย่างเดียว */
                                        create_no_parts || create_parts.length === 0 ? (
                                            <div className="bg-white border rounded-3 p-3 text-secondary text-12">{create_no_parts ? t("no_parts_requisition") : t("no_requested_parts")}</div>
                                        ) : (
                                            <div className="bg-white border rounded-3 p-3">
                                                <div className="fw-bold text-dark text-14 mb-3 d-flex align-items-center">
                                                    <span className="icon me-2" style={{ color: "#D97706" }}>
                                                        {"\uf466"}
                                                    </span>
                                                    {t("requested_parts")}
                                                    <span className="badge bg-light text-secondary fw-normal ms-2 border text-11">
                                                        {create_parts.length} {t("items")}
                                                    </span>
                                                </div>
                                                <div className="table-responsive">
                                                    <table className="table table-sm align-middle mb-0">
                                                        <thead>
                                                            <tr className="text-secondary text-12" style={{ backgroundColor: "#EFF4FF" }}>
                                                                <th className="fw-bold py-2">{t("part_code")}</th>
                                                                <th className="fw-bold py-2">{t("part_name")}</th>
                                                                <th className="fw-bold py-2 text-end">{t("requested_quantity")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {create_parts.map((part) => (
                                                                <tr key={part.key} className="border-bottom">
                                                                    <td className="fw-bold text-dark text-12 py-2">{part.part_number || "-"}</td>
                                                                    <td className="text-dark text-12 py-2">{part.part_name || "-"}</td>
                                                                    <td className="text-dark text-12 py-2 text-end">
                                                                        {formatNumber(part.quantity)} {part.uom_name || ""}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td className="fw-bold text-12 py-2" style={{ color: "#2563EB" }} colSpan={2}>
                                                                    {t("total_all")} ({formatNumber(create_parts.length)} {t("items")})
                                                                </td>
                                                                <td className="fw-bold text-12 py-2 text-end" style={{ color: "#2563EB" }}>
                                                                    {formatNumber(this.getRequestedPartsTotal())}
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                                {create_parts_required_date && (
                                                    <div className="d-flex align-items-center gap-2 mt-3 text-12">
                                                        <span className="fw-bold text-secondary">{t("parts_required_date")}</span>
                                                        <span className="text-dark">{format_date(create_parts_required_date, "dd/mm/yyyy", "th")}</span>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    ) : (
                                        <>
                                            <div className="bg-white border rounded-3 p-2 mb-3 d-flex align-items-center flex-wrap gap-2">
                                                <input
                                                    id="wr-no-parts-requisition"
                                                    className="form-check-input pointer me-2 mt-0"
                                                    type="checkbox"
                                                    checked={create_no_parts || partsClosed}
                                                    disabled={partsClosed}
                                                    onChange={(e) => this.handleToggleNoParts(e.target.checked)}
                                                />
                                                <label className="form-check-label fw-bold text-14 pointer mb-0" htmlFor="wr-no-parts-requisition">
                                                    {t("no_parts_requisition")}
                                                </label>
                                                {partsClosed && <span className="ms-auto text-12 text-secondary">{t("parts_requisition_disabled_by_category")}</span>}
                                                {!create_no_parts && !partsClosed && (
                                                    <div className="ms-auto d-flex align-items-center gap-2">
                                                        <label className="text-12 fw-bold mb-0" htmlFor="wr-parts-required-date">
                                                            {t("parts_required_date")}
                                                        </label>
                                                        <div style={{ width: 170 }}>
                                                            <DatePicker
                                                                type="th"
                                                                className="form-control form-control-sm"
                                                                placeholder={t("date_placeholder")}
                                                                value={create_parts_required_date || ""}
                                                                onChange={(val) => this.setState({ create_parts_required_date: val || "" })}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {create_no_parts || partsClosed ? null : !this.canRequestParts() ? (
                                                <div className="text-12" style={{ color: "#B45309" }}>
                                                    {t("parts_requisition_prerequisite_hint")}
                                                </div>
                                            ) : (
                                                <>
                                                    {create_parts.length > 0 ? (
                                                        <div className="bg-white border rounded-3 mb-3 table-responsive">
                                                            <table className="table table-sm align-middle mb-0">
                                                                <thead>
                                                                    <tr className="text-secondary text-12" style={{ backgroundColor: "#EFF4FF" }}>
                                                                        <th className="fw-bold py-2 px-3">{t("part_code")}</th>
                                                                        <th className="fw-bold py-2 px-3">{t("part_name")}</th>
                                                                        <th className="fw-bold py-2 px-3 wpx-160">{t("requested_quantity")}</th>
                                                                        <th className="fw-bold py-2 px-3 wpx-60"></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {create_parts.map((part) => (
                                                                        <tr key={part.key} className="border-bottom">
                                                                            <td className="fw-bold text-dark text-12 py-2 px-3">{part.part_number || "-"}</td>
                                                                            <td className="text-dark text-12 py-2 px-3">{part.part_name || "-"}</td>
                                                                            <td className="py-2 px-3">
                                                                                <div className="d-flex align-items-center">
                                                                                    <input
                                                                                        type="number"
                                                                                        min="1"
                                                                                        className="form-control form-control-sm text-center"
                                                                                        style={{ width: "72px" }}
                                                                                        value={part.quantity}
                                                                                        onChange={(e) => this.handleRequestedPartChange(part.key, e.target.value)}
                                                                                    />
                                                                                    <span className="ms-2 text-secondary text-12 fw-bold">{part.uom_name || ""}</span>
                                                                                </div>
                                                                            </td>
                                                                            <td className="py-2 px-3 text-end">
                                                                                <span className="icon text-danger pointer" onClick={() => this.handleRemoveRequestedPart(part.key)}>
                                                                                    {"\uf00d"}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <div className="border rounded-3 p-3 bg-white text-secondary text-12 mb-3">{t("no_requested_parts")}</div>
                                                    )}

                                                    <div className="border rounded-3 p-3 bg-white" style={{ borderStyle: "dashed" }}>
                                                        <div className="text-dark fw-bold text-12 mb-2 d-flex align-items-center">
                                                            <span className="icon me-2">{"\uf067"}</span> {t("add_requested_part")}
                                                        </div>
                                                        <div className="d-flex align-items-stretch gap-2">
                                                            <Select
                                                                className="form-control flex-grow-1"
                                                                options={data_parts}
                                                                onSearch={this.searchParts}
                                                                value={create_part_id}
                                                                placeholder={t("search_parts_placeholder")}
                                                                onChange={(e) => this.setState({ create_part_id: e })}
                                                            />
                                                            <button
                                                                className="btn btn-primary border fw-bold d-flex align-items-center justify-content-center flex-shrink-0"
                                                                style={{ minWidth: "90px" }}
                                                                onClick={this.handleAddRequestedPart}
                                                            >
                                                                + {t("add")}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Section 8: มอบหมายงานต่อ (ท้ายฟอร์ม) */}
                            <div className="mb-2">
                                <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center text-14">
                                    <span className="icon me-2 text-16">{"\uf0ea"}</span> {t("handoff_next_work")}
                                </h6>
                                <div className="bg-white rounded-3 p-3 border">
                                    <label className="form-label text-dark fw-bold text-14">
                                        {t("responsible_department")} <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        className="form-control mb-3"
                                        options={data_departments}
                                        value={create_assigned_department_id}
                                        placeholder={t("select_department")}
                                        onChange={(e) => this.setState({ create_assigned_department_id: e })}
                                    />

                                    <div className="text-dark fw-bold text-14 mb-2">{t("next_document_type_label")}</div>
                                    <div className="row g-3">
                                        {NEXT_DOCUMENT_TYPES.map((docType) => {
                                            const isSelected = create_next_document_type === docType.value;
                                            // \u0e2b\u0e21\u0e27\u0e14\u0e2b\u0e21\u0e39\u0e48\u0e04\u0e33\u0e23\u0e49\u0e2d\u0e07\u0e17\u0e35\u0e48\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e1b\u0e34\u0e14\u0e1b\u0e23\u0e30\u0e40\u0e20\u0e17\u0e40\u0e2d\u0e01\u0e2a\u0e32\u0e23\u0e19\u0e35\u0e49\u0e44\u0e27\u0e49 (\u0e2b\u0e19\u0e49\u0e32\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32\u0e43\u0e1a\u0e07\u0e32\u0e19 > \u0e2b\u0e21\u0e27\u0e14\u0e2b\u0e21\u0e39\u0e48\u0e04\u0e33\u0e23\u0e49\u0e2d\u0e07 > \u0e41\u0e01\u0e49\u0e44\u0e02\u0e2b\u0e21\u0e27\u0e14\u0e2b\u0e21\u0e39\u0e48) -> \u0e40\u0e25\u0e37\u0e2d\u0e01\u0e44\u0e21\u0e48\u0e44\u0e14\u0e49
                                            const isDisabledByCategory = !!selectedCategory && selectedCategory[docType.enableField] === false;
                                            const isDisabled = view_mode || isDisabledByCategory;

                                            return (
                                                <div className="col-12 col-md-4" key={docType.value}>
                                                    <div
                                                        className={`rounded-3 p-3 h-100 text-center position-relative ${isDisabled ? "" : "pointer"}`}
                                                        style={{
                                                            border: `2px solid ${isSelected ? docType.color : "#E5E7EB"}`,
                                                            backgroundColor: isSelected ? docType.softColor : "#FFFFFF",
                                                            opacity: isDisabledByCategory ? 0.5 : 1,
                                                            cursor: isDisabledByCategory ? "not-allowed" : undefined,
                                                        }}
                                                        title={isDisabledByCategory ? t("doc_type_disabled_hint") : undefined}
                                                        onClick={() => {
                                                            if (isDisabled) return;
                                                            this.setState({ create_next_document_type: docType.value });
                                                        }}
                                                    >
                                                        <span
                                                            className="position-absolute top-0 end-0 m-2 rounded-circle d-inline-flex align-items-center justify-content-center text-10 text-white"
                                                            style={{
                                                                width: "18px",
                                                                height: "18px",
                                                                border: `2px solid ${isSelected ? docType.color : "#D1D5DB"}`,
                                                                backgroundColor: isSelected ? docType.color : "transparent",
                                                            }}
                                                        >
                                                            {isSelected ? <span className="icon">{"\uf00c"}</span> : null}
                                                        </span>
                                                        <div
                                                            className="rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                                                            style={{
                                                                width: "56px",
                                                                height: "56px",
                                                                backgroundColor: isSelected ? docType.color : "#F3F4F6",
                                                                color: isSelected ? "#FFFFFF" : "#9CA3AF",
                                                            }}
                                                        >
                                                            <span className="icon text-20">{docType.icon}</span>
                                                        </div>
                                                        <div className="fw-bold text-14" style={{ color: isSelected ? docType.color : "#374151" }}>
                                                            {t(docType.labelKey)}
                                                        </div>
                                                        <div className="text-10 text-secondary text-uppercase">{docType.caption}</div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            {/* ผู้สร้างใบคำร้อง - แสดงอย่างเดียว แก้ไขไม่ได้ */}
                            {view_mode && (
                                <div className="mb-2">
                                    <label className="form-label text-dark fw-bold text-14">{t("created_by_col")}</label>
                                    <input type="text" className="form-control text-14" value={this.getRequestCreatorText(active_request)} disabled />
                                </div>
                            )}
                        </fieldset>
                    </Modal.Body>

                    {close_job_mode ? (
                        <Modal.Footer className="bg-white border-top px-4 py-3 d-block">
                            {canCloseJob ? (
                                <div className="text-center text-12 mb-1" style={{ color: closeJobDocumentType?.color || "#2563EB" }}>
                                    {closeJobDocumentType ? t(closeJobDocumentType.closeHintKey) : ""}
                                </div>
                            ) : (
                                <div className="text-center text-12 mb-1 text-danger">
                                    <span className="icon me-1">{"\uf071"}</span>
                                    {t("close_job_missing_fields")}: {closeJobMissingFields.join(", ")}
                                </div>
                            )}
                            <button className="btn btn-success w-100 py-2 fw-bold rounded-3 shadow-sm" onClick={this.SubmitCloseJob} disabled={!canCloseJob}>
                                <span className="icon me-2">{"\uf00c"}</span>
                                {create_next_document_type === "work_order" ? t("close_job_create_wo") : t("close_job")}
                            </button>
                        </Modal.Footer>
                    ) : (
                        <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-between align-items-center gap-2">
                            {selectedProcessView ? (
                                <div className="text-12 fw-bold d-flex align-items-center" style={{ color: selectedProcessView.color }}>
                                    <span className="icon me-2">{selectedProcessView.icon}</span>
                                    {t("process_name")}: {t(selectedProcessView.labelKey)}
                                </div>
                            ) : (
                                <div className="text-12 text-secondary d-flex align-items-center">
                                    <span className="icon me-2">{"\uf05a"}</span>
                                    {t("process_name_from_category")}
                                </div>
                            )}
                            <div className="d-flex gap-2">
                                <button className="btn btn-white border px-4 py-2" onClick={() => this.setState({ modal_create: false, ...this.getCreateFormState() })}>
                                    {view_mode ? t("close") : t("cancel")}
                                </button>
                                {/* Save Draft: หน้าสร้างใหม่ และการแก้ไขใบที่ยังเป็นแบบร่าง (ไม่บังคับช่องจำเป็น) */}
                                {!view_mode && (!uid || active_request?.status === "draft") && (
                                    <button className="btn btn-outline-secondary px-4 py-2" onClick={() => this.CreateUpdate(true)}>
                                        {t("save_draft")}
                                    </button>
                                )}
                                {!view_mode && (
                                    <button className="btn btn-primary px-4 py-2" onClick={() => this.CreateUpdate(false)}>
                                        {uid && active_request?.status !== "draft" ? t("save") : `+ ${t("create_request")}`}
                                    </button>
                                )}
                            </div>
                        </Modal.Footer>
                    )}
                </Modal>

                {/* ===================== Fast Call Modal ===================== */}
                <Modal
                    size="lg"
                    show={modal_fast_call}
                    onHide={() => this.setState({ modal_fast_call: false, fast_call_view_mode: false, ...this.getFastCallFormState() })}
                    centered
                    contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
                >
                    <Modal.Header className="bg-white p-4 border-bottom" closeButton>
                        <div className="w-100">
                            <h3 className="fw-bold mb-1 text-dark d-flex align-items-center">
                                <span className="icon me-2 text-dark">{"\uf095"}</span>
                                {fast_call_view_mode ? t("view_fast_call_info") : t("record_fast_call_result")}
                            </h3>
                            <div className="text-secondary text-14">
                                {active_request?.wr_number || "-"} • {this.getCustomerDisplayName(active_request?.customer)}
                            </div>
                            {/* Workflow Steps */}
                            <div className="d-flex w-100 overflow-auto mt-3" style={{ gap: "2px" }}>
                                <div
                                    className="bg-success text-white px-3 py-2 fw-bold text-12 rounded-start d-flex align-items-center position-relative flex-grow-1 justify-content-center"
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%)" }}
                                >
                                    <span className="icon me-1">{"\uf00c"}</span>
                                    <span className="">{t("wr_created")}</span>
                                </div>
                                <div
                                    className={`${
                                        active_request?.fast_call ? "bg-success text-white" : "bg-warning text-white border"
                                    } px-3 py-2 fw-bold text-12 d-flex align-items-center position-relative flex-grow-1 justify-content-center`}
                                    style={{ clipPath: "polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    {active_request?.fast_call ? <span className="icon me-1">{"\uf00c"}</span> : null}
                                    <span className="">{t("call_result_recorded")}</span>
                                </div>
                                <div
                                    className={`${
                                        active_request?.fast_call && active_request.status !== "rejected" ? "bg-success text-white" : "bg-light text-secondary border"
                                    } px-3 py-2 fw-bold text-12 rounded-end d-flex align-items-center position-relative flex-grow-1 justify-content-center`}
                                    style={{ clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 5% 50%)", marginLeft: "-5px" }}
                                >
                                    {active_request?.fast_call && active_request?.fast_call?.status === "success" ? <span className="icon me-1">{"\uf00c"}</span> : null}
                                    <span className="">
                                        {active_request?.fast_call && active_request?.fast_call?.status === "success"
                                            ? t("close_job")
                                            : active_request?.fast_call && active_request?.fast_call?.status !== "success" && active_request.status !== "rejected"
                                              ? t("issue_wo")
                                              : t("close_job_or_issue_wo")}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="px-4 py-4 bg-white" style={{ maxHeight: "75vh", overflowY: "auto" }}>
                        <div className="rounded-3 border px-4 py-3 mb-4" style={{ backgroundColor: "#EFF6FF", borderColor: "#BFDBFE" }}>
                            <div className="text-primary fw-bold text-16">🔧 {active_request?.problem_description || "-"}</div>
                        </div>

                        <div className="mb-3 pb-2 border-bottom">
                            <div className="fw-bold text-secondary text-16">
                                <span className="icon me-2">{"\uf095"}</span>
                                {t("call_details")}
                            </div>
                        </div>

                        <div className="row g-3 mb-4">
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold">
                                    {t("calling_technician")} <span className="text-danger">*</span>
                                </label>
                                <Select
                                    className="form-control"
                                    options={fastCallTechnicianOptions}
                                    value={fast_call_technician}
                                    placeholder={t("select_calling_technician")}
                                    onChange={(e) => this.setState({ fast_call_technician: e })}
                                    disabled={fast_call_view_mode}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold">
                                    {t("call_datetime")} <span className="text-danger">*</span>
                                </label>
                                <div className="d-flex gap-2">
                                    <DatePicker
                                        type="th"
                                        className="form-control py-2"
                                        value={fast_call_date}
                                        onChange={(val) => this.setState({ fast_call_date: val })}
                                        disabled={fast_call_view_mode}
                                    />
                                    <input
                                        type="time"
                                        className="form-control py-2"
                                        style={{ maxWidth: "120px" }}
                                        value={fast_call_time}
                                        onChange={(e) => this.setState({ fast_call_time: e.target.value })}
                                        disabled={fast_call_view_mode}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold">{t("call_duration_minutes")}</label>
                                <input
                                    type="text"
                                    className="form-control py-2"
                                    placeholder={t("eg_15_minutes")}
                                    value={fast_call_duration}
                                    onChange={(e) => this.setState({ fast_call_duration: e.target.value.replace(/\D/g, "") })}
                                    disabled={fast_call_view_mode}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-dark fw-bold">{t("call_channel_label")}</label>
                                <select className="form-select py-2" value={fast_call_channel} onChange={(e) => this.setState({ fast_call_channel: e.target.value })} disabled={fast_call_view_mode}>
                                    <option value="โทรศัพท์ตรง">{t("direct_phone_call")}</option>
                                    <option value="Line Call">Line Call</option>
                                    <option value="Video Call">Video Call</option>
                                </select>
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="form-label text-dark fw-bold">{t("customer_reported_symptom_summary")}</label>
                            {/* ISS-003: ช่องสรุปอาการจำกัด 20 ตัวอักษร (ช่อง "แนวทางแก้ไข" ด้านล่างยังเป็น 500 ตามเดิม
                                เพราะมีเงื่อนไขบังคับขั้นต่ำ 30 ตัวอักษรอยู่แล้ว) */}
                            <textarea
                                className="form-control py-3"
                                rows="2"
                                maxLength={FAST_CALL_SYMPTOM_MAX}
                                placeholder={t("call_detail_placeholder")}
                                value={fast_call_symptom}
                                onChange={(e) => this.setState({ fast_call_symptom: e.target.value.slice(0, FAST_CALL_SYMPTOM_MAX) })}
                                disabled={fast_call_view_mode}
                            ></textarea>
                            <div className="text-muted text-12 mt-1 text-end">
                                {(fast_call_symptom || "").length} / {FAST_CALL_SYMPTOM_MAX}
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="form-label text-dark fw-bold">
                                {t("recommended_solution_label")} <span className="text-danger">*</span>
                            </label>
                            <textarea
                                className="form-control py-3"
                                rows="4"
                                maxLength={500}
                                placeholder={t("solution_guidance_placeholder")}
                                value={fast_call_guidance}
                                onChange={(e) => this.setState({ fast_call_guidance: e.target.value })}
                                disabled={fast_call_view_mode}
                            ></textarea>
                            <div className="text-muted text-12 mt-1 text-end">{(fast_call_guidance || "").length} / 500</div>
                        </div>

                        <div className="mb-3 pb-2 border-bottom">
                            <div className="fw-bold text-secondary text-16">{t("resolution_result_select_one")}</div>
                        </div>

                        <div className="row g-3">
                            <div className="col-md-6">
                                <div
                                    className={`rounded-4 border p-4 text-center pointer h-100 transition-hover ${fast_call_result === "closed" ? "shadow-sm" : ""}`}
                                    style={{
                                        borderWidth: fast_call_result === "closed" ? "3px" : "1px",
                                        borderColor: fast_call_result === "closed" ? "#059669" : "#D1FAE5",
                                        backgroundColor: fast_call_result === "closed" ? "#BBF7D0" : "#F0FDF4",
                                        boxShadow: fast_call_result === "closed" ? "0 0 0 5px rgba(16, 185, 129, 0.28), 0 14px 30px rgba(5, 150, 105, 0.18)" : "none",
                                        transform: fast_call_result === "closed" ? "translateY(-2px)" : "none",
                                        position: "relative",
                                    }}
                                    onClick={() => !fast_call_view_mode && this.setState({ fast_call_result: "closed" })}
                                >
                                    {fast_call_result === "closed" && (
                                        <div
                                            className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center text-white fw-bold"
                                            style={{
                                                width: "36px",
                                                height: "36px",
                                                backgroundColor: "#059669",
                                                borderBottomLeftRadius: "16px",
                                                borderTopRightRadius: "14px",
                                            }}
                                        >
                                            ✓
                                        </div>
                                    )}
                                    <div className="text-success text-40 mb-2">{fast_call_result === "closed" ? "✅" : "☑️"}</div>
                                    <div className="fw-bold text-success text-20 mb-2">{t("resolved_close_job")}</div>
                                    <div className="text-secondary">
                                        {t("customer_confirmed_normal_operation")}
                                        <br />
                                        {t("system_will_close_wo_as_phone_fix")}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div
                                    className={`rounded-4 border p-4 text-center pointer h-100 transition-hover ${fast_call_result === "visit" ? "shadow-sm" : ""}`}
                                    style={{
                                        borderWidth: fast_call_result === "visit" ? "3px" : "1px",
                                        borderColor: fast_call_result === "visit" ? "#2563EB" : "#BFDBFE",
                                        backgroundColor: fast_call_result === "visit" ? "#BFDBFE" : "#EFF6FF",
                                        boxShadow: fast_call_result === "visit" ? "0 0 0 5px rgba(59, 130, 246, 0.28), 0 14px 30px rgba(37, 99, 235, 0.18)" : "none",
                                        transform: fast_call_result === "visit" ? "translateY(-2px)" : "none",
                                        position: "relative",
                                    }}
                                    onClick={() => !fast_call_view_mode && this.setState({ fast_call_result: "visit" })}
                                >
                                    {fast_call_result === "visit" && (
                                        <div
                                            className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center text-white fw-bold"
                                            style={{
                                                width: "36px",
                                                height: "36px",
                                                backgroundColor: "#2563EB",
                                                borderBottomLeftRadius: "16px",
                                                borderTopRightRadius: "14px",
                                            }}
                                        >
                                            ✓
                                        </div>
                                    )}
                                    <div className="text-primary text-40 mb-2">{fast_call_result === "visit" ? "🔧" : "🛠️"}</div>
                                    <div className="fw-bold text-primary text-20 mb-2">{t("requires_onsite_visit")}</div>
                                    <div className="text-secondary">
                                        {t("cannot_resolve_by_phone")}
                                        <br />
                                        {t("system_will_create_onsite_wo_after_approval")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end align-items-center">
                        <div className="d-flex gap-2">
                            <button
                                className="btn btn-white border px-4 py-2 rounded-3 fw-bold"
                                onClick={() => this.setState({ modal_fast_call: false, fast_call_view_mode: false, ...this.getFastCallFormState() })}
                            >
                                {fast_call_view_mode ? t("close") : t("cancel")}
                            </button>
                            {!fast_call_view_mode && (
                                <button
                                    className="btn btn-primary px-4 py-2 rounded-3 fw-bold text-white"
                                    style={{
                                        opacity: fast_call_result ? 1 : 0.55,
                                        cursor: fast_call_result ? "pointer" : "not-allowed",
                                    }}
                                    onClick={this.submitFastCall}
                                    disabled={!fast_call_result}
                                >
                                    {!fast_call_result ? t("save_result") : fast_call_result === "closed" ? t("save_and_close_job") : t("save_result")}
                                </button>
                            )}
                        </div>
                    </Modal.Footer>
                </Modal>

                {/* ===================== APPROVE MODAL ===================== */}
                <Modal size="md" show={modal_approve} onHide={() => this.setState({ modal_approve: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
                    <Modal.Header className="bg-white border-bottom px-4 py-3" closeButton>
                        <div className="d-flex align-items-center">
                            <div className="wpx-25 hpx-25 rounded-circle bg-success text-white d-flex align-items-center justify-content-center me-2">
                                <span className="icon text-12">{"\uf00c"}</span>
                            </div>
                            <h5 className="fw-bold mb-0 text-dark">{t("approve_work_request")}</h5>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="p-4 bg-white">
                        <div className="bg-light rounded-3 p-3 mb-4 d-flex justify-content-between align-items-start border ">
                            <div>
                                <div className="text-secondary text-12 mb-1">{t("request_id")}</div>
                                <h5 className="fw-bold text-dark mb-3">{active_request?.wr_number || ""}</h5>
                                <div className="text-secondary text-14">
                                    {t("customer_label")} <span className="text-dark fw-bold">{this.getCustomerDisplayName(active_request?.customer)}</span>
                                </div>
                                <div className="text-secondary text-14">
                                    {t("asset_label")} <span className="text-dark">{active_request?.asset?.part_name || ""}</span>
                                </div>
                                {/* ISS-002: ผู้ดำเนินการ (ผู้สร้าง/ผู้อนุมัติ) พร้อมเวลาที่ดำเนินการ */}
                                <div className="text-secondary text-14 mt-2">
                                    {t("created_by_label")} <span className="text-dark fw-bold">{active_request?.created_by_user?.full_name || "-"}</span>
                                    {active_request?.created_at ? ` (${format_date(active_request.created_at, "dd/mm/yyyy hh:mm", "th")})` : ""}
                                </div>
                                {active_request?.approved_by_user && (
                                    <div className="text-secondary text-14">
                                        {t("approved_by_label")} <span className="text-dark fw-bold">{active_request.approved_by_user.full_name}</span>
                                        {active_request?.approved_at ? ` (${format_date(active_request.approved_at, "dd/mm/yyyy hh:mm", "th")})` : ""}
                                    </div>
                                )}
                            </div>
                            <span className="badge rounded-pill fw-bold px-3 py-1 text-12" style={this.getPriorityStyle(active_request?.priority?.name_th || "")}>
                                {active_request?.priority?.name_th || ""}
                            </span>
                        </div>

                        <div className="mb-3">
                            <label className="form-label text-14 text-dark fw-bold">{t("work_order_type")}</label>
                            <Select className="form-control" placeholder={t("select_req_category")} options={data_categories} value={create_category_id} disabled />
                        </div>

                        <div className="row g-3 mb-4">
                            <div className="col-md-6">
                                <label className="form-label text-14 text-dark fw-bold">{t("wr_urgency_level")}</label>
                                <Select className="form-control" placeholder={t("wr_select_urgency_level")} options={data_priorities} value={create_priority_id} disabled />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label text-14 text-dark fw-bold">{t("sla_template")}</label>
                                <input type="text" className="form-control" value={text_priority_id} disabled />
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="form-label text-14 text-dark fw-bold">{t("assign_technicians_optional")}</label>

                            <div className="border border-purple rounded-3 overflow-hidden">
                                <div className="bg-purple-light p-2 d-flex align-items-center border-bottom border-purple">
                                    <div className="wpx-25 hpx-25 rounded-circle bg-purple text-white d-flex align-items-center justify-content-center me-2">
                                        <span className="icon text-12">{"\uf040"}</span>
                                    </div>
                                    <span className="text-purple fw-bold me-2">{t("ai_recommended_technicians")}</span>
                                    <span className="badge bg-purple-light text-purple rounded-pill fw-normal text-10">{t("based_on_job_requirements")}</span>
                                </div>

                                <div className="p-3 bg-white">
                                    <div className="d-flex flex-column gap-3">
                                        {technicians.map((tech, idx) => (
                                            <div key={idx} className={`border rounded-3 p-3 position-relative ${tech.bestMatch ? "border-success bg-success-light-light" : " bg-white shadow-sm"}`}>
                                                {tech.bestMatch && (
                                                    <div className="position-absolute top-0 end-0 bg-success text-white px-2 py-1 text-10 fw-bold" style={{ borderBottomLeftRadius: "8px" }}>
                                                        <span className="icon me-1">{"\uf521"}</span> {t("best_match")}
                                                    </div>
                                                )}

                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                    <div className="d-flex align-items-center">
                                                        <div
                                                            className="wpx-40 hpx-40 rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-16 me-3"
                                                            style={{ backgroundColor: tech.bg }}
                                                        >
                                                            {tech.initials}
                                                        </div>
                                                        <div>
                                                            <div className="fw-bold text-dark text-16">{tech.name}</div>
                                                            <div className="text-secondary text-12 d-flex align-items-center">
                                                                <div className={`wpx-8 hpx-8 rounded-circle bg-${tech.statusColor} me-1`}></div>
                                                                <span className={`text-${tech.statusColor} fw-bold me-2`}>{tech.status}</span>
                                                                <span className="icon text-10 me-1">{"\uf041"}</span> {tech.distance}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button className={`btn btn-sm px-3 rounded-pill fw-bold ${tech.bestMatch ? "btn-success" : "btn-outline-primary bg-white"}`}>+ {t("add")}</button>
                                                </div>

                                                <div className="d-flex flex-wrap gap-2 mb-2">
                                                    {tech.tags.map((tag, tIdx) => (
                                                        <span key={tIdx} className={`badge bg-${tag.color}-light text-${tag.color} rounded-2 px-2 py-1 text-10 border border-${tag.color}`}>
                                                            <span className="icon me-1">{tag.icon}</span> {tag.text}
                                                        </span>
                                                    ))}
                                                </div>

                                                {tech.hint && (
                                                    <div className={`text-${tech.hintColor} text-12 fst-italic mt-2`}>
                                                        <span className="icon me-1">{tech.hintIcon}</span> {tech.hint}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    <div className="text-center mt-3 pt-2 border-top">
                                        <a href="#" className="text-purple text-decoration-none fw-bold text-14">
                                            <span className="icon me-1">{"\uf0ca"}</span> {t("view_all_available_technicians")}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="text-secondary text-14">
                            {t("selected_technicians")} <span className="fst-italic">{t("none")}</span>
                        </div>

                        <div className="mt-4 pt-4 border-top">
                            <a href="#" className="text-secondary text-decoration-none text-14 d-block mb-3">
                                <span className="icon me-1">{"\uf054"}</span> {t("select_manually")}
                            </a>

                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("required_parts")}</label>
                            <div className="border rounded-3 p-3 mb-4">
                                <div className="form-check mb-2">
                                    <input className="form-check-input" type="checkbox" defaultChecked id="part1" />
                                    <label className="form-check-label text-dark text-14" htmlFor="part1">
                                        Compressor Motor 2HP (Qty: 1)
                                    </label>
                                </div>
                                <div className="form-check mb-2">
                                    <input className="form-check-input" type="checkbox" defaultChecked id="part2" />
                                    <label className="form-check-label text-dark text-14" htmlFor="part2">
                                        Refrigerant R-410A (Qty: 2kg)
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="part3" />
                                    <label className="form-check-label text-dark text-14" htmlFor="part3">
                                        Filter Drier (Qty: 1)
                                    </label>
                                </div>
                            </div>

                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("internal_notes")}</label>
                            <textarea className="form-control" rows="3" placeholder={t("add_notes_placeholder")}></textarea>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end gap-2">
                        <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_approve: false })}>
                            {t("cancel")}
                        </button>
                        <button className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold text-white shadow-sm">
                            <span className="icon me-2">{"\uf00c"}</span> {t("create_work_order")}
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* ===================== RETURN MODAL ===================== */}
                <Modal size="md" show={modal_return} onHide={() => this.setState({ modal_return: false })} centered>
                    <Modal.Header className="bg-white px-4 pt-4 pb-0 border-0" closeButton>
                        <div className="d-flex align-items-center">
                            <span className="icon text-dark me-2 text-20 fw-bold">{RETURN_ICON}</span>
                            <h4 className="fw-bold mb-0 text-dark">
                                {t("wr_return_title")} {active_request?.wr_number || ""}
                            </h4>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="px-4 pb-2 pt-3 bg-white">
                        <div className="text-secondary text-14 mb-3">{t("wr_return_hint")}</div>
                        <label className="form-label text-dark fw-bold text-16">
                            {t("wr_return_reason")} <span className="text-danger">*</span>
                        </label>
                        <textarea
                            className="form-control py-2"
                            rows="4"
                            placeholder={t("wr_return_reason_placeholder")}
                            value={return_reason}
                            onChange={(e) => this.setState({ return_reason: e.target.value })}
                        ></textarea>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-0 px-4 pb-4 pt-2 d-flex justify-content-end gap-2">
                        <button className="btn btn-white border px-4 py-2" onClick={() => this.setState({ modal_return: false })}>
                            {t("cancel")}
                        </button>
                        <button className="btn btn-primary px-4 py-2" onClick={this.SubmitReturn} disabled={!return_reason.trim()}>
                            {t("wr_return_confirm")}
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* ===================== REJECT MODAL ===================== */}
                <Modal size="md" show={modal_reject} onHide={() => this.setState({ modal_reject: false, reject_view_mode: false })} centered>
                    <Modal.Header className="bg-white px-4 pt-4 pb-0 border-0" closeButton>
                        <div className="d-flex align-items-center">
                            <span className="icon text-dark me-2 text-20 fw-bold">{"\uf00d"}</span>
                            <h4 className="fw-bold mb-0 text-dark">{reject_view_mode ? `${t("view")} ${t("reject_reason")}` : t("reject_work_request")}</h4>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="px-4 pb-2 pt-3 bg-white">
                        <div className="mb-2">
                            <label className="form-label text-dark fw-bold text-16">
                                {t("reject_reason")} {!reject_view_mode && <span className="text-danger">*</span>}
                            </label>
                            <Select
                                className="form-control"
                                placeholder={t("select_reject_reason")}
                                onChange={(e, i) => {
                                    this.setState({ reject_reason_id: e });
                                }}
                                value={reject_reason_id}
                                options={data_reject_reasons}
                                disabled={reject_view_mode}
                            />
                        </div>

                        <div className="mb-3 mt-3">
                            <label className="form-label text-dark fw-bold text-16">{t("additional_note")}</label>
                            <textarea
                                className="form-control py-2 "
                                rows="4"
                                placeholder={t("additional_notes")}
                                value={reject_note}
                                onChange={(e) => this.setState({ reject_note: e.target.value })}
                                disabled={reject_view_mode}
                            ></textarea>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="bg-white border-0 px-4 pb-4 pt-2 d-flex justify-content-end gap-2">
                        <button className="btn btn-white border px-4 py-2" onClick={() => this.setState({ modal_reject: false, reject_view_mode: false })}>
                            {reject_view_mode ? t("close") : t("cancel")}
                        </button>
                        {!reject_view_mode && (
                            <button className="btn btn-danger px-4 py-2" onClick={this.SubmitReject}>
                                {t("confirm_reject")}
                            </button>
                        )}
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
